(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 4878:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(35039);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* reexport */ homepage; }
});

// EXTERNAL MODULE: ../../../node_modules/path/path.js
var path = __webpack_require__(8565);
var path_default = /*#__PURE__*/__webpack_require__.n(path);
// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-logs/esm/entries/main.js + 20 modules
var main = __webpack_require__(39806);
;// CONCATENATED MODULE: ../../../libs/shared/customer-journey-cookies/src/lib/shared-customer-journey.types.ts
var ChannelValue;
(function(ChannelValue) {
    ChannelValue["awin"] = "aw";
    ChannelValue["ppcBrand"] = "aw";
    ChannelValue["ppcGeneric"] = "ppc";
    ChannelValue["facebook"] = "fb";
    ChannelValue["tiktok"] = "tiktok";
    ChannelValue["direct"] = "aw";
})(ChannelValue || (ChannelValue = {}));

;// CONCATENATED MODULE: ../../../libs/shared/customer-journey-cookies/src/lib/shared-customer-journey-cookies.helper.ts


const getParamValue = (param)=>{
    var ref;
    if (!window.location) return null;
    const params = (ref = window.location) === null || ref === void 0 ? void 0 : ref.search;
    const searchParams = new URLSearchParams(params);
    return searchParams.get(param);
};
const getChannel = ()=>{
    var ref;
    if (!window.location) return ChannelValue.direct;
    const params = window.location.search;
    main/* datadogLogs.logger.info */.fy.logger.info("AWIN URL search params", {
        location: window.location,
        params: params
    });
    const searchParams = new URLSearchParams(params);
    const awc = searchParams.has("awc");
    const CID = (ref = searchParams.get("CID")) === null || ref === void 0 ? void 0 : ref.toLowerCase();
    const gclid = searchParams.has("gclid");
    const fbclid = searchParams.has("fbclid");
    const channelConditionsList = [
        {
            priority: 1,
            channelName: "ppcGeneric",
            condition: gclid && !(CID === null || CID === void 0 ? void 0 : CID.includes("brand")),
            channelValue: ChannelValue.ppcGeneric
        },
        {
            priority: 2,
            channelName: "ppcBrand",
            condition: gclid && !!(CID === null || CID === void 0 ? void 0 : CID.includes("brand")),
            channelValue: ChannelValue.ppcBrand
        },
        {
            priority: 3,
            channelName: "facebook",
            condition: fbclid && !!(CID === null || CID === void 0 ? void 0 : CID.includes("social")) && (CID.includes("meta") || CID.includes("facebook")),
            channelValue: ChannelValue.facebook
        },
        {
            priority: 4,
            channelName: "tiktok",
            condition: !!(CID === null || CID === void 0 ? void 0 : CID.includes("tiktok")),
            channelValue: ChannelValue.tiktok
        },
        {
            priority: 5,
            channelName: "awin",
            condition: awc,
            channelValue: ChannelValue.awin
        },
        {
            priority: 6,
            channelName: "direct",
            condition: !CID && !awc,
            channelValue: ChannelValue.direct
        }
    ];
    const channelConditionValues = channelConditionsList.filter((channelCondition)=>channelCondition.condition);
    return channelConditionValues.length > 0 ? channelConditionValues.sort((a, b)=>a.priority - b.priority)[0].channelValue : ChannelValue.direct;
};
const shared_customer_journey_cookies_helper_getCookie = ({ name  })=>{
    var ref;
    return (ref = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)) === null || ref === void 0 ? void 0 : ref.pop();
};
const cookieBuilder = (key, data, expiryDay)=>{
    main/* datadogLogs.logger.info */.fy.logger.info("AWIN cookie data", {
        data: data
    });
    const expiryDate = new Date();
    const cookieValue = JSON.stringify(data);
    const daysToMilliseconds = expiryDay * 8.64e7;
    expiryDate.setTime(expiryDate.getTime() + daysToMilliseconds);
    const expires = `expires=${expiryDate.toUTCString()}`;
    return `${key}=${cookieValue};${expires};path=/`;
};
// Will only work for objects that are one level deep
const compareObjects = (object1, object2)=>{
    for(const key in object1){
        // eslint-disable-next-line no-prototype-builtins
        if (object1.hasOwnProperty(key) && object1[key] !== object2[key]) {
            return false;
        }
    }
    for(const key1 in object2){
        // eslint-disable-next-line no-prototype-builtins
        if (object2.hasOwnProperty(key1) && object1[key1] !== object2[key1]) {
            return false;
        }
    }
    return true;
};

;// CONCATENATED MODULE: ../../../libs/shared/customer-journey-cookies/src/lib/shared-customer-journey-cookies.ts

const sharedCustomerJourneyCookies = ()=>({
        commissionGroup: getParamValue("parts") ?? "DEFAULT",
        channel: getChannel(),
        awc: getParamValue("awc"),
        voucher: getParamValue("voucher") ?? ""
    });
const saveCustomerJourneyCookie = ()=>{
    if (true) {
        const isAwcInQueryParameter = !!getParamValue("awc");
        const hasAWINCookie = !!shared_customer_journey_cookies_helper_getCookie({
            name: "awin"
        });
        if (isAwcInQueryParameter) {
            const buildCookieData = sharedCustomerJourneyCookies();
            document.cookie = cookieBuilder("awin", buildCookieData, 30);
            return {
                data: buildCookieData,
                message: "Cookie successfully saved"
            };
        }
        if (!isAwcInQueryParameter && hasAWINCookie) {
            const oldCookie = JSON.parse(shared_customer_journey_cookies_helper_getCookie({
                name: "awin"
            }));
            const newCookie = {
                ...oldCookie,
                channel: getChannel()
            };
            if (compareObjects(oldCookie, newCookie)) {
                return {
                    data: oldCookie,
                    message: "Cookie value not updated"
                };
            }
            document.cookie = cookieBuilder("awin", newCookie, 30);
            return {
                data: newCookie,
                message: "Cookie successfully updated"
            };
        }
        return {
            data: null,
            message: "unable to save cookie"
        };
    } else {}
};
const getCustomerJourneyCookie = ()=>{
    const awinCustomerJourneyCookie = getCookie({
        name: "awin"
    });
    const hasCustomerJourney = !!awinCustomerJourneyCookie;
    if (hasCustomerJourney) {
        return {
            data: JSON.parse(awinCustomerJourneyCookie),
            message: ""
        };
    }
    return {
        data: null,
        message: "unable to get customer journey cookie"
    };
};
const clearCustomerJourneyCookie = ()=>{
    const hasCustomerJourney = !!getCookie({
        name: "awin"
    });
    if (hasCustomerJourney) {
        document.cookie = `awin=;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
        return {
            message: "Cleared customer journey cookie"
        };
    }
    return {
        message: "Unable to find customer journey cookie"
    };
};

;// CONCATENATED MODULE: ../../../libs/shared/customer-journey-cookies/src/index.ts


// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 287 modules
var shared_src = __webpack_require__(40405);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 118 modules
var ui_src = __webpack_require__(32014);
// EXTERNAL MODULE: ../../../libs/shared/analytics/src/index.ts + 26 modules
var analytics_src = __webpack_require__(40731);
// EXTERNAL MODULE: ../../../node_modules/classnames/index.js
var classnames = __webpack_require__(95685);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-rum/esm/entries/main.js + 111 modules
var entries_main = __webpack_require__(50163);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/filters/tracking.ts



const { Actions , Context  } = shared_src/* Datadog */.og;
const getValueOrAny = (value)=>value ? value : "any";
function createTrackers(trackEvent) {
    return {
        onChange ({ trackEventLabel , trackEventAction , value , datadogActionName , trackEventSection  }) {
            trackEvent({
                eventName: `Homepage ${trackEventLabel} dropdown`,
                type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
                data: {
                    event: {
                        name: analytics_src/* EventNames.click */.Vy.click,
                        category: "hero",
                        action: trackEventAction,
                        label: trackEventLabel,
                        value: value === null || value === void 0 ? void 0 : value.toLowerCase(),
                        section: trackEventSection === null || trackEventSection === void 0 ? void 0 : trackEventSection.toLowerCase()
                    }
                }
            });
            entries_main/* datadogRum.addAction */.v.addAction(datadogActionName, {
                service: Context.HERO_SEARCH,
                squad: Context.SQUAD,
                page: window.location.pathname,
                value: value === null || value === void 0 ? void 0 : value.toLowerCase()
            });
        },
        onSubmit (selectedMake, selectedModel, price, trackEventSection) {
            let trackEventName = "Homepage filter search all cars";
            let actionName = "";
            const searchTrackEventValue = `search all cars make: ${getValueOrAny(selectedMake)}, model: ${getValueOrAny(selectedModel)}, ${getValueOrAny(price)}`;
            if (selectedMake) {
                trackEventName = "Homepage filter search now";
                actionName = selectedModel ? `${selectedMake},${selectedModel}` : `${selectedMake}`;
            }
            trackEvent({
                eventName: trackEventName,
                type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
                data: {
                    action: actionName,
                    event: {
                        name: analytics_src/* EventNames.click */.Vy.click,
                        category: "hero",
                        action: "submit",
                        label: "search all cars",
                        value: searchTrackEventValue,
                        section: trackEventSection === null || trackEventSection === void 0 ? void 0 : trackEventSection.toLowerCase()
                    }
                }
            });
            entries_main/* datadogRum.addAction */.v.addAction(Actions.CLICK_SEARCH_CTA, {
                service: Context.HERO_SEARCH,
                squad: Context.SQUAD,
                page: window.location.pathname,
                value: searchTrackEventValue
            });
        }
    };
}

// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/filters/filters.module.css
var filters_module = __webpack_require__(25338);
var filters_module_default = /*#__PURE__*/__webpack_require__.n(filters_module);
// EXTERNAL MODULE: ../../../libs/shared/util/src/index.ts + 25 modules
var util_src = __webpack_require__(37479);
// EXTERNAL MODULE: ../../../libs/shared/environments/src/index.ts + 5 modules
var environments_src = __webpack_require__(48114);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/utils/decorate-options.ts
function decorateOptions(options, count) {
    const shouldDecorate = options.findIndex((option)=>option.value === "any") === -1;
    if (shouldDecorate) {
        options.unshift({
            label: `Any`,
            value: "any",
            count: `${count}`
        });
    }
    return options;
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/filters/handlers.ts
/* eslint-disable unicorn/no-useless-undefined */ 



const { Actions: handlers_Actions  } = shared_src/* Datadog */.og;
const formatPrice = (price)=>price ? `£${price}` : "any";
const VEHICLE_SEARCH_URL = `${(0,environments_src/* readFromEnv */.u)(environments_src/* Env.SearchServiceUrl */.X.SearchServiceUrl)}/vehicles`;
const TOTAL_PRICE = "total-price";
const MONTHLY_PRICE = "monthly-price";
function getSearchButtonText(quantity) {
    return quantity === 1 ? "Search 1 car" : `Search ${(0,util_src/* formatNumber */.uf)(quantity)} cars`;
}
function onMakeSelected({ setSelectedMake , setSelectedModel , setMakeOptions , section , handleOnChangeTracking , event  }) {
    const isPlaceholderSelected = event.target.value === "Select make";
    const value = event.target.value === "Any" || isPlaceholderSelected ? undefined : event.target.value;
    handleOnChangeTracking({
        trackEventLabel: "make",
        trackEventAction: "select",
        value,
        datadogActionName: handlers_Actions.SELECT_MAKE_OPTION,
        trackEventSection: section
    });
    setSelectedMake(value || "");
    setMakeOptions((makes)=>removeStockCountFromSelectedMake(makes, event.target.value));
    setSelectedModel(undefined);
}
function onModelSelected({ setSelectedModel , handleOnChangeTracking , event , section  }) {
    const value = event.target.value === "Any" ? undefined : event.target.value;
    handleOnChangeTracking({
        trackEventLabel: "model",
        trackEventAction: "select",
        value,
        datadogActionName: handlers_Actions.SELECT_MODEL_OPTION,
        trackEventSection: section
    });
    setSelectedModel(value || "");
}
function onSubmit({ handleOnSubmitTracking , maxTotalPrice , radioChecked , selectedMake , selectedModel , event , section  }) {
    const price = radioChecked === MONTHLY_PRICE ? `monthly price: ${formatPrice(maxTotalPrice)}` : `total price: ${formatPrice(maxTotalPrice)}`;
    handleOnSubmitTracking(selectedMake, selectedModel, price, section);
    event.preventDefault();
    const urlParams = new URLSearchParams();
    if (maxTotalPrice && maxTotalPrice !== -1) {
        urlParams.append("toPrice", maxTotalPrice.toString());
    }
    if (radioChecked === MONTHLY_PRICE) {
        urlParams.append("useMonthly", "true");
    }
    let url = `/used-cars`;
    if (selectedMake && selectedMake !== "any") {
        url += `/${(0,util_src/* dashify */.P1)(selectedMake)}`;
    }
    if (selectedModel && selectedModel !== "any" && selectedMake && selectedMake !== "any") {
        url += `/${(0,util_src/* dashify */.P1)(selectedModel)}`;
    }
    window.location.assign(`${url}?${urlParams.toString()}`);
}
async function updateSearchButtonLabel({ selectedMake , selectedModel , radioChecked , maxTotalPrice , setButtonText  }) {
    const urlParams = new URLSearchParams({
        pageSize: "0"
    });
    if (selectedMake && selectedMake !== "any") {
        urlParams.append("make", selectedMake);
    }
    if (selectedModel && selectedModel !== "any" && selectedMake && selectedMake !== "any") {
        urlParams.append("model", selectedModel);
    }
    if (radioChecked === MONTHLY_PRICE) {
        urlParams.append("useMonthly", "true");
    }
    if (maxTotalPrice !== undefined) {
        urlParams.append("toPrice", maxTotalPrice.toString());
    }
    const response = await getSearchResults(urlParams);
    const buttonText = getSearchButtonText(response.searchResultsCount);
    setButtonText(buttonText);
}
async function updateStockLevels({ selectedMake , selectedModel , radioChecked , maxTotalPrice , totalStock , setMakeOptions , setModelOptions , setPriceBucket , setMonthlyPriceBucket  }) {
    const urlParams = new URLSearchParams();
    if (selectedMake && selectedMake !== "any") {
        urlParams.append("make", selectedMake);
    }
    if (selectedModel && selectedModel !== "any" && selectedMake && selectedMake !== "any") {
        urlParams.append("model", selectedModel);
    }
    if (radioChecked === MONTHLY_PRICE) {
        urlParams.append("useMonthly", "true");
    }
    if (maxTotalPrice !== undefined) {
        urlParams.append("toPrice", maxTotalPrice.toString());
    }
    const response = await getSearchResults(urlParams);
    const { makes  } = response.facets;
    if (maxTotalPrice !== undefined) {
        const urlParams1 = new URLSearchParams({
            perPage: "0"
        });
        if (radioChecked === MONTHLY_PRICE) {
            urlParams1.append("useMonthly", "true");
        }
        urlParams1.append("toPrice", maxTotalPrice.toString());
        const data = await getSearchResults(urlParams1);
        totalStock = data.searchResultsCount;
    }
    const makeOptions = decorateOptions(makes.map((data)=>toMakes(data)).map((make)=>{
        let label = `${make.name}`;
        if (make.name !== selectedMake) {
            label += ` (${(0,util_src/* formatNumber */.uf)(make.stock)})`;
        }
        return {
            label: label,
            value: make.name,
            count: `${make.stock}`
        };
    }), totalStock || 0);
    setMakeOptions(makeOptions);
    if (selectedMake && selectedMake !== "any") {
        const make = makes.map((data)=>toMakes(data)).find((make)=>make.name === selectedMake);
        const modelTotalStock = response.searchResultsCount;
        const modelOptions = modelToOptions((make === null || make === void 0 ? void 0 : make.models) ?? [], selectedModel);
        const decoratedModelOptions = decorateOptions(modelOptions, modelTotalStock || 0);
        setModelOptions(decoratedModelOptions);
    }
    setPriceBucket(response.facets.priceBucket);
    setMonthlyPriceBucket(response.facets.monthlyPriceBucket);
}
function updateModelOptions({ selectedMake , selectedModel , makes , setModelOptions  }) {
    if (selectedMake && !/any/gi.test(selectedMake)) {
        const make = makes.find((make)=>make.name === selectedMake);
        setModelOptions(modelToOptions(make.models, selectedModel));
        return;
    }
    setModelOptions([]);
}
function modelToOptions(models, selectedModel) {
    return models.map((model)=>{
        let label = `${model.name}`;
        if (model.name !== selectedModel) {
            label += ` (${(0,util_src/* formatNumber */.uf)(model.stock)})`;
        }
        return {
            label,
            value: model.name,
            count: `${model.stock}`
        };
    });
}
async function getSearchResults(urlParams) {
    const url = `${VEHICLE_SEARCH_URL}?${urlParams.toString()}`;
    const request = await fetch(url);
    const response = await request.json();
    return response;
}
function toMakes(make) {
    return {
        name: make.name,
        stock: make.doc_count,
        models: make.models.map((model)=>({
                name: model.name,
                stock: model.doc_count
            }))
    };
}
function removeStockCountFromSelectedMake(makes, selectedMake) {
    if (selectedMake && selectedMake !== "any") {
        return makes.map((make)=>{
            if (make.value === selectedMake) {
                make.label = selectedMake;
            }
            return make;
        });
    }
    return makes;
}

// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/filters/price/price.module.css
var price_module = __webpack_require__(80387);
var price_module_default = /*#__PURE__*/__webpack_require__.n(price_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/filters/pay-options.ts
const ANY_PRICE = -1;
const payFullRange = [
    {
        label: "\xa35,500",
        value: 5500,
        rangeKey: "5500-6000"
    },
    {
        label: "\xa36,000",
        value: 6000,
        rangeKey: "6000-6500"
    },
    {
        label: "\xa36,500",
        value: 6500,
        rangeKey: "6500-7000"
    },
    {
        label: "\xa37,000",
        value: 7000,
        rangeKey: "7000-7500"
    },
    {
        label: "\xa37,500",
        value: 7500,
        rangeKey: "7500-8000"
    },
    {
        label: "\xa38,000",
        value: 8000,
        rangeKey: "8000-8500"
    },
    {
        label: "\xa38,500",
        value: 8500,
        rangeKey: "8500-9000"
    },
    {
        label: "\xa39,000",
        value: 9000,
        rangeKey: "9000-9500"
    },
    {
        label: "\xa39,500",
        value: 9500,
        rangeKey: "9500-10000"
    },
    {
        label: "\xa310,000",
        value: 10000,
        rangeKey: "10000-11000"
    },
    {
        label: "\xa311,000",
        value: 11000,
        rangeKey: "11000-12000"
    },
    {
        label: "\xa312,000",
        value: 12000,
        rangeKey: "12000-13000"
    },
    {
        label: "\xa313,000",
        value: 13000,
        rangeKey: "13000-14000"
    },
    {
        label: "\xa314,000",
        value: 14000,
        rangeKey: "14000-15000"
    },
    {
        label: "\xa315,000",
        value: 15000,
        rangeKey: "15000-20000"
    },
    {
        label: "\xa320,000",
        value: 20000,
        rangeKey: "20000-25000"
    },
    {
        label: "\xa325,000",
        value: 25000,
        rangeKey: "25000-30000"
    },
    {
        label: "\xa330,000",
        value: 30000,
        rangeKey: "30000-40000"
    },
    {
        label: "\xa340,000",
        value: 40000,
        rangeKey: "40000-50000"
    },
    {
        label: "\xa350,000",
        value: 50000,
        rangeKey: "50000-*"
    }
];
const payMonthlyRange = [
    {
        label: "\xa350 p/m",
        value: 50,
        rangeKey: "50-100"
    },
    {
        label: "\xa3100 p/m",
        value: 100,
        rangeKey: "100-150"
    },
    {
        label: "\xa3150 p/m",
        value: 150,
        rangeKey: "150-200"
    },
    {
        label: "\xa3200 p/m",
        value: 200,
        rangeKey: "200-250"
    },
    {
        label: "\xa3250 p/m",
        value: 250,
        rangeKey: "250-300"
    },
    {
        label: "\xa3300 p/m",
        value: 300,
        rangeKey: "300-350"
    },
    {
        label: "\xa3350 p/m",
        value: 350,
        rangeKey: "350-400"
    },
    {
        label: "\xa3400 p/m",
        value: 400,
        rangeKey: "400-450"
    },
    {
        label: "\xa3450 p/m",
        value: 450,
        rangeKey: "450-500"
    },
    {
        label: "\xa3500 p/m",
        value: 500,
        rangeKey: "500-550"
    },
    {
        label: "\xa3550 p/m",
        value: 550,
        rangeKey: "550-600"
    },
    {
        label: "\xa3600 p/m",
        value: 600,
        rangeKey: "600-650"
    },
    {
        label: "\xa3650 p/m",
        value: 650,
        rangeKey: "650-700"
    },
    {
        label: "\xa3700 p/m",
        value: 700,
        rangeKey: "700-750"
    },
    {
        label: "\xa3750 p/m",
        value: 750,
        rangeKey: "750-800"
    },
    {
        label: "\xa3800 p/m",
        value: 800,
        rangeKey: "800-850"
    },
    {
        label: "\xa3850 p/m",
        value: 850,
        rangeKey: "850-900"
    },
    {
        label: "\xa3900 p/m",
        value: 900,
        rangeKey: "900-950"
    },
    {
        label: "\xa3950 p/m",
        value: 950,
        rangeKey: "950-*"
    }
];

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/filters/price/helpers/convert-to-range-facet.ts
function convertKeyCountIntoPriceRangeWithFacetCount(key, count) {
    const [from, to] = key.split("-");
    const fromAsNumber = Number.parseInt(from, 10);
    const toAsNumber = Number.parseInt(to, 10);
    const response = {
        count
    };
    if (!Number.isNaN(fromAsNumber)) response.from = fromAsNumber;
    if (!Number.isNaN(toAsNumber)) response.to = toAsNumber;
    return response;
}
function isDefined(value) {
    return typeof value !== "undefined" && value !== null;
}
/**
 * convertIntoRangeFacet accepts rangeLikeFacet is a key pair value with key in pattern of <value>-<value> e,g, 7000-8000
 */ function convertIntoRangeFacet(rangeLikeFacet) {
    return Object.entries(rangeLikeFacet).map(([key, count])=>{
        const rangeFacet = convertKeyCountIntoPriceRangeWithFacetCount(key, count);
        return key ? rangeFacet : undefined;
    }) // eslint-disable-next-line unicorn/no-array-callback-reference
    .filter(isDefined).sort((a, b)=>{
        if (!a.to) return 1;
        if (!b.to) return -1;
        return a.to - b.to;
    });
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/filters/price/helpers/fill-in-missing-range-facets.ts
function fillInMissingRangeFacets(staticIncrements, dynamicRangeFacets) {
    const updatedFacets = {
        ...dynamicRangeFacets
    };
    staticIncrements.forEach(({ rangeKey  })=>{
        if (dynamicRangeFacets[rangeKey] === undefined) {
            updatedFacets[rangeKey] = 0;
        }
    });
    return updatedFacets;
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/filters/price/helpers/get-to-price-facet-counts.ts
const getToPriceFacetCountsWhenFromPriceIs = (priceRanges, selectedValue = -1)=>{
    let tally = 0;
    return [
        ...priceRanges
    ].filter((priceRange)=>selectedValue === -1 || (priceRange.to ? priceRange.to > selectedValue : false)).map((priceRange)=>({
            value: priceRange.to,
            doc_count: tally += priceRange.count
        })).reduce((accumulator, currentPriceRange)=>{
        const currentValue = currentPriceRange.value;
        if (currentValue !== undefined) {
            accumulator[String(currentValue)] = currentPriceRange.doc_count;
        }
        return accumulator;
    }, {});
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/filters/price/helpers/create-label-with-facet-count.ts
const createLabelWithFacetCount = (facetData, currentOption, selectedPrice = -1, useMonthly = false)=>{
    const { label , value  } = currentOption;
    const valueAsKey = useMonthly ? value * 100 : value;
    const isNotCurrentValue = facetData[valueAsKey] !== undefined && selectedPrice !== value;
    return `${label} ${isNotCurrentValue ? `(${facetData[valueAsKey].toLocaleString()})` : ""}`;
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/filters/price/price.tsx










const { Actions: price_Actions  } = shared_src/* Datadog */.og;
const Price = ({ monthlyPriceBucket , priceBucket , radioChecked , maxTotalPrice , setMaxTotalPrice , handleOnChangeTracking  })=>{
    const toPrice = [
        maxTotalPrice.toString()
    ];
    const selectedToPrice = toPrice.length === 0 ? ANY_PRICE : Number(toPrice[0]);
    const selectedFromPrice = ANY_PRICE;
    const useMonthly = radioChecked === MONTHLY_PRICE;
    const priceFacets = convertIntoRangeFacet(fillInMissingRangeFacets(payFullRange, priceBucket));
    const monthlyPriceFacets = convertIntoRangeFacet(fillInMissingRangeFacets(payMonthlyRange, monthlyPriceBucket));
    function onPriceSelected({ setMaxTotalPrice , handleOnChangeTracking , event  }) {
        const value = event.target.value;
        const id = useMonthly ? MONTHLY_PRICE : TOTAL_PRICE;
        const isTotalPrice = id === TOTAL_PRICE;
        const priceType = isTotalPrice ? "total price" : "monthly price";
        const datadogActionName = isTotalPrice ? price_Actions.SELECT_MAX_PRICE_OPTION : price_Actions.SELECT_MONTHLY_PRICE_OPTION;
        handleOnChangeTracking({
            trackEventLabel: priceType,
            trackEventAction: "select",
            value,
            datadogActionName
        });
        setMaxTotalPrice(Number.parseInt(value || "0"));
    }
    const getRange = ()=>useMonthly ? payMonthlyRange : payFullRange;
    const toPriceSelectOptions = [
        {
            label: "Any",
            value: ANY_PRICE
        },
        ...getRange().map(({ label , value  })=>({
                label,
                value
            }))
    ];
    const toPriceFacetCounts = getToPriceFacetCountsWhenFromPriceIs(useMonthly ? monthlyPriceFacets : priceFacets);
    const filteredToPriceSelectOptions = toPriceSelectOptions.filter((item)=>{
        if (selectedFromPrice === ANY_PRICE) return true;
        return item.value === ANY_PRICE;
    }).map((item)=>({
            value: item.value,
            label: createLabelWithFacetCount(toPriceFacetCounts, item, selectedToPrice, useMonthly)
        }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SelectField */.mg, {
        label: "Select price",
        labelHidden: true,
        id: "price",
        "data-testid": "price-select",
        options: filteredToPriceSelectOptions,
        placeholder: useMonthly ? "Max monthly budget" : "Max total price",
        placeholderValue: "",
        value: (maxTotalPrice === null || maxTotalPrice === void 0 ? void 0 : maxTotalPrice.toString()) ?? "-1",
        onChange: (event)=>onPriceSelected({
                setMaxTotalPrice: setMaxTotalPrice,
                handleOnChangeTracking,
                event
            }),
        error: {
            show: false,
            classNames: {
                container: (price_module_default()).errorBox
            }
        },
        name: "toPrice",
        classNames: {
            container: (price_module_default()).toPriceSelect
        }
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/filters/filters.tsx











const { Actions: filters_Actions , Context: filters_Context  } = shared_src/* Datadog */.og;
const Filters = ({ totalStock , makes , starRatingLabel , starRating , numberOfReviews , section  })=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const [radioChecked, setRadioChecked] = (0,react.useState)(MONTHLY_PRICE);
    const [maxTotalPrice, setMaxTotalPrice] = (0,react.useState)(0);
    const [selectedMake, setSelectedMake] = (0,react.useState)();
    const [selectedModel, setSelectedModel] = (0,react.useState)();
    const [makeOptions, setMakeOptions] = (0,react.useState)(decorateOptions(makes.map((make)=>({
            label: `${make.name} (${make.stock})`,
            value: make.name,
            count: `${make.stock}`
        })), totalStock));
    const [searchButtonText, setSearchButtonText] = (0,react.useState)(getSearchButtonText(totalStock));
    const [modelOptions, setModelOptions] = (0,react.useState)([]);
    const [priceBucket, setPriceBucket] = (0,react.useState)({});
    const [monthlyPriceBucket, setMonthlyPriceBucket] = (0,react.useState)({});
    const { onChange: handleOnChangeTracking , onSubmit: handleOnSubmitTracking  } = createTrackers(trackEvent);
    const handleTrackEvent = ()=>{
        entries_main/* datadogRum.addAction */.v.addAction(filters_Actions.CLICK_HMC_LINK_IN_FILTERS_SECTION, {
            service: filters_Context.HERO_HMC,
            squad: filters_Context.SQUAD,
            page: "/",
            category: "hero",
            label: "help-me-choose-click - inside find a car",
            value: `help-me-choose-click`
        });
        trackEvent({
            eventName: `Help me choose inside find a car - click`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: "click",
                    category: "hero",
                    label: "inside find a car",
                    action: "Help me choose"
                }
            }
        });
    };
    (0,react.useEffect)(()=>{
        updateSearchButtonLabel({
            selectedMake,
            selectedModel,
            radioChecked,
            maxTotalPrice,
            setButtonText: setSearchButtonText
        }).catch((error)=>{
            setSearchButtonText(getSearchButtonText(totalStock));
            console.error("Unable to update search button label cause:", error);
            entries_main/* datadogRum.addError */.v.addError(error);
        });
    }, [
        selectedMake,
        selectedModel,
        radioChecked,
        maxTotalPrice
    ]);
    (0,react.useEffect)(()=>{
        updateStockLevels({
            selectedMake,
            selectedModel,
            maxTotalPrice,
            radioChecked,
            totalStock,
            setModelOptions,
            setMakeOptions,
            setPriceBucket,
            setMonthlyPriceBucket
        }).catch((error)=>{
            setMakeOptions(decorateOptions(makes.map((make)=>({
                    label: `${make.name} (${make.stock})`,
                    value: make.name,
                    count: `${make.stock}`
                })), totalStock));
            setModelOptions([]);
            console.error("Unable to stock levels:", error);
            entries_main/* datadogRum.addError */.v.addError(error);
        });
    }, [
        selectedMake,
        selectedModel,
        radioChecked,
        maxTotalPrice
    ]);
    (0,react.useEffect)(()=>{
        updateModelOptions({
            selectedMake,
            selectedModel,
            makes,
            setModelOptions
        });
    }, [
        selectedMake,
        selectedModel,
        makes
    ]);
    (0,react.useEffect)(()=>{
        if (!selectedMake && selectedMake !== "") {
            setSelectedMake("");
        }
    }, [
        selectedMake
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (filters_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                element: "h1",
                className: (filters_module_default()).heading,
                children: "Buy used cars online"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: (filters_module_default()).form,
                onSubmit: (event)=>onSubmit({
                        handleOnSubmitTracking,
                        maxTotalPrice,
                        radioChecked,
                        selectedMake,
                        selectedModel,
                        event,
                        section
                    }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SelectField */.mg, {
                        label: "Select make",
                        labelHidden: true,
                        id: "make",
                        name: "make",
                        "data-testid": "make-select",
                        options: makeOptions,
                        placeholder: "Select make",
                        placeholderValue: "Any",
                        value: selectedMake,
                        onChange: (event)=>onMakeSelected({
                                setSelectedMake,
                                setSelectedModel,
                                setMakeOptions,
                                handleOnChangeTracking,
                                event,
                                section
                            }),
                        error: {
                            show: false,
                            classNames: {
                                container: (filters_module_default()).errorBox
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SelectField */.mg, {
                        label: "Select model",
                        labelHidden: true,
                        id: "model",
                        name: "model",
                        "data-testid": "model-select",
                        options: modelOptions,
                        placeholder: "Select model",
                        placeholderValue: "Any",
                        value: selectedModel,
                        onChange: (event)=>onModelSelected({
                                setSelectedModel,
                                handleOnChangeTracking,
                                event,
                                section
                            }),
                        disabled: !selectedMake || selectedMake.toLocaleLowerCase() === "any",
                        error: {
                            show: false,
                            classNames: {
                                container: (filters_module_default()).errorBox
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                        className: (filters_module_default()).radioGroup,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (filters_module_default()).radioInputContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    htmlFor: MONTHLY_PRICE,
                                    className: (filters_module_default()).priceLabel,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "radio",
                                            id: MONTHLY_PRICE,
                                            name: MONTHLY_PRICE,
                                            checked: radioChecked === MONTHLY_PRICE,
                                            onChange: ()=>{
                                                setRadioChecked(MONTHLY_PRICE);
                                                setMaxTotalPrice(0);
                                                handleOnChangeTracking({
                                                    trackEventLabel: "monthly price",
                                                    trackEventAction: "button",
                                                    value: `${MONTHLY_PRICE} checked`,
                                                    datadogActionName: filters_Actions.CLICK_MONTHLY_PRICE_RADIO
                                                });
                                            }
                                        }),
                                        "Monthly price"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (filters_module_default()).radioInputContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    htmlFor: TOTAL_PRICE,
                                    className: (filters_module_default()).priceLabel,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "radio",
                                            id: TOTAL_PRICE,
                                            name: TOTAL_PRICE,
                                            checked: radioChecked === TOTAL_PRICE,
                                            onChange: ()=>{
                                                setRadioChecked(TOTAL_PRICE);
                                                setMaxTotalPrice(0);
                                                handleOnChangeTracking({
                                                    trackEventLabel: "total price",
                                                    trackEventAction: "button",
                                                    value: `${TOTAL_PRICE} checked`,
                                                    datadogActionName: filters_Actions.CLICK_TOTAL_PRICE_RADIO
                                                });
                                            }
                                        }),
                                        "Total price"
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, {
                        radioChecked: radioChecked,
                        handleOnChangeTracking: handleOnChangeTracking,
                        maxTotalPrice: maxTotalPrice,
                        setMaxTotalPrice: setMaxTotalPrice,
                        priceBucket: priceBucket,
                        monthlyPriceBucket: monthlyPriceBucket
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (filters_module_default()).buttonContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                            type: "submit",
                            classNames: {
                                button: (filters_module_default()).button
                            },
                            "data-testid": "searchButton",
                            isFullWidth: true,
                            children: searchButtonText
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (filters_module_default()).helpMeChoose,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Not sure where to start?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "Try our ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://www.cinch.co.uk/help-me-choose/most-important",
                                        className: (filters_module_default()).link,
                                        onClick: ()=>handleTrackEvent(),
                                        children: "Help Me Choose tool"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/filters/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/utils/create-breaks.tsx


/**
 * Converts a string with new lines to a string with <br /> tags
 * without dangerouslySetInnerHTML
 * @param text string with new lines (\n)
 */ function replaceNewLinesWithBreaks(text) {
    return text.split("\n").map((text, index, lines)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                text,
                index !== lines.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
            ]
        }, index + "-" + text));
}

// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/hero-heading/hero-heading.module.css
var hero_heading_module = __webpack_require__(3897);
var hero_heading_module_default = /*#__PURE__*/__webpack_require__.n(hero_heading_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/hero-heading/hero-heading.tsx



function HeroHeading({ heading  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
        className: (hero_heading_module_default()).heading,
        "data-testid": "hero-heading",
        children: replaceNewLinesWithBreaks(heading)
    });
}

// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/hero-subheading/hero-subheading.module.css
var hero_subheading_module = __webpack_require__(48291);
var hero_subheading_module_default = /*#__PURE__*/__webpack_require__.n(hero_subheading_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/hero-subheading/hero-subheading.tsx



function HeroSubheading({ subheading  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
        className: (hero_subheading_module_default()).subheading,
        "data-testid": "hero-subheading",
        children: replaceNewLinesWithBreaks(subheading)
    });
}

// EXTERNAL MODULE: ../../../node_modules/next/link.js
var next_link = __webpack_require__(89218);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/hero-link/hero-link.module.css
var hero_link_module = __webpack_require__(1131);
var hero_link_module_default = /*#__PURE__*/__webpack_require__.n(hero_link_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/hero-link/hero-link.tsx





function HeroLink({ link , text , trackEvent , ...rest }) {
    if (!text || !link.url) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: link.url,
        passHref: true,
        legacyBehavior: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            ...(0,src/* storyblokEditable */.LF)({
                ...rest,
                link,
                text
            }),
            className: (hero_link_module_default()).promoLink,
            target: link.linktype === "url" ? "_blank" : undefined,
            href: "#shop-now",
            onClick: ()=>trackEvent({
                    eventName: `promo hero link`,
                    type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
                    data: {
                        event: {
                            name: "click",
                            category: "link",
                            label: `Promo link click`,
                            action: `Promo Link link click`
                        }
                    }
                }),
            children: text
        })
    });
}

// EXTERNAL MODULE: ../../../node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(19601);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/hero-image/hero-image.module.css
var hero_image_module = __webpack_require__(61012);
var hero_image_module_default = /*#__PURE__*/__webpack_require__.n(hero_image_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/hero-image/hero-image.tsx





function HeroImage({ isMobileImageShown , image  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((hero_image_module_default()).imageContainer, {
            [(hero_image_module_default()).isShownOnMobile]: isMobileImageShown
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: image.filename,
            alt: image.alt ?? "Hero Image",
            loader: src/* storyblokImageLoader */.BE,
            priority: true,
            layout: "intrinsic",
            width: 700,
            height: 240
        })
    });
}

// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/hero.module.css
var hero_module = __webpack_require__(80044);
var hero_module_default = /*#__PURE__*/__webpack_require__.n(hero_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/hero-v2/hero.tsx












const HomeHeroV2 = (props)=>{
    const { makes , totalStock , starRating , starRatingLabel , heading , subheading , heroLink: [heroLink] , image , isMobileImageShown , numberOfReviews  } = props;
    const { vw  } = (0,util_src/* useViewport */.Sj)({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const isMobile = vw < 1024;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (hero_module_default()).container,
        "aria-describedby": "hero-heading",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((hero_module_default()).background, (hero_module_default()).backgroundGradient),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (hero_module_default()).heroInner,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((hero_module_default()).textAndImageContainer, {
                                [(hero_module_default()).isMobileImageShown]: isMobileImageShown
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (hero_module_default()).textContainer,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroHeading, {
                                            heading: heading
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSubheading, {
                                            subheading: subheading
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroLink, {
                                            ...heroLink,
                                            trackEvent: trackEvent
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (hero_module_default()).imageGridContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroImage, {
                                        image: image,
                                        isMobileImageShown: isMobileImageShown
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters, {
                            makes: makes,
                            totalStock: totalStock,
                            starRating: starRating,
                            starRatingLabel: starRatingLabel,
                            numberOfReviews: numberOfReviews
                        })
                    ]
                })
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (hero_module_default()).trustpilotMobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* TrustpilotOverviewV2 */.vO, {
                    starRating: starRating,
                    starRatingLabel: starRatingLabel,
                    numberOfReviews: numberOfReviews,
                    className: (hero_module_default()).trustpilotOverview
                })
            }),
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                backgroundColor: "#f8f6ff",
                className: {
                    inner: (hero_module_default()).trustpilotWrapper
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* TrustpilotWidget */.cE, {
                    height: "24px",
                    widget: isMobile ? ui_src/* TrustpilotWidgetTemplates.microStar */.sd.microStar : ui_src/* TrustpilotWidgetTemplates.microCombo */.sd.microCombo
                })
            })
        ]
    });
};
/* harmony default export */ var hero = (HomeHeroV2);

// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/shop-by-shape/shop-by-shape-card/shop-by-shape-card.module.css
var shop_by_shape_card_module = __webpack_require__(49997);
var shop_by_shape_card_module_default = /*#__PURE__*/__webpack_require__.n(shop_by_shape_card_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/shop-by-shape/shop-by-shape-card/shop-by-shape-card.tsx








const ShopByShapeCard = /*#__PURE__*/ (0,react.forwardRef)(({ title , image , count , minSeats , maxSeats , filterQuery , alt  }, ref)=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const handleClick = ()=>{
        trackEvent({
            eventName: `Shop by type: ${title}`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: "button",
                    label: "Shop by type",
                    action: title.toLowerCase()
                }
            }
        });
    };
    const { vw  } = (0,util_src/* useViewport */.Sj)({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isMobile = vw < 1024;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: `/used-cars/${filterQuery}`,
        passHref: true,
        legacyBehavior: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            "data-testid": "shop-by-shape-card",
            className: (shop_by_shape_card_module_default()).card,
            onClick: handleClick,
            href: "/used-cars",
            ref: ref,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image,
                    layout: "responsive",
                    width: 248,
                    height: 115,
                    alt: alt
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shop_by_shape_card_module_default()).heading,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            element: "h4",
                            className: (shop_by_shape_card_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (shop_by_shape_card_module_default()).body,
                            children: `${minSeats} - ${maxSeats} seats`
                        })
                    ]
                }),
                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (shop_by_shape_card_module_default()).link,
                    children: `Shop ${count} cars`
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Secondary */.T7, {
                    element: "span",
                    classNames: {
                        button: (shop_by_shape_card_module_default()).button
                    },
                    "aria-label": "Shop by shape card",
                    children: `Shop ${count} cars`
                })
            ]
        })
    });
});
/* harmony default export */ var shop_by_shape_card = (ShopByShapeCard);

// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/shop-by-shape/shop-by-shape-component.module.css
var shop_by_shape_component_module = __webpack_require__(67997);
var shop_by_shape_component_module_default = /*#__PURE__*/__webpack_require__.n(shop_by_shape_component_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/shop-by-shape/shop-by-shape-component.tsx





const ShopByShape = ({ count  })=>{
    const carShapes = [
        {
            title: "SUV",
            image: "/shop-by-shape/suv.png",
            count: count.suv,
            minSeats: 5,
            maxSeats: 7,
            filterQuery: "suv-body-type",
            alt: "SUV car"
        },
        {
            title: "Electric",
            image: "/shop-by-shape/electric.png",
            count: count.electric,
            minSeats: 2,
            maxSeats: 7,
            filterQuery: "electric-fuel-type",
            alt: "Electric car"
        },
        {
            title: "Hatchback",
            image: "/shop-by-shape/hatchback.png",
            count: count.hatchback,
            minSeats: 4,
            maxSeats: 5,
            filterQuery: "hatchback-body-type",
            alt: "Hatchback car"
        },
        {
            title: "Estate",
            image: "/shop-by-shape/estate.png",
            count: count.estate,
            minSeats: 5,
            maxSeats: 7,
            filterQuery: "estate-body-type",
            alt: "Estate car"
        },
        {
            title: "Coupe",
            image: "/shop-by-shape/coupe.png",
            count: count.coupe,
            minSeats: 2,
            maxSeats: 4,
            filterQuery: "coupe-body-type",
            alt: "Coupe car"
        },
        {
            title: "Convertible",
            image: "/shop-by-shape/convertible.png",
            count: count.convertible,
            minSeats: 2,
            maxSeats: 5,
            filterQuery: "convertible-body-type",
            alt: "Convertible car"
        },
        {
            title: "Saloon",
            image: "/shop-by-shape/saloon.png",
            count: count.saloon,
            minSeats: 4,
            maxSeats: 5,
            filterQuery: "saloon-body-type",
            alt: "Saloon car"
        },
        {
            title: "MPV",
            image: "/shop-by-shape/mpv.png",
            count: count.mpv,
            minSeats: 5,
            maxSeats: 7,
            filterQuery: "mpv-body-type",
            alt: "Multi-purpose vehicle car"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Wrapper */.im, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                element: "h3",
                fontSize: "h1",
                className: (shop_by_shape_component_module_default()).heading,
                children: "Shop by shape"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                isFluid: true,
                className: {
                    container: (shop_by_shape_component_module_default()).container,
                    inner: (shop_by_shape_component_module_default()).inner
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shop_by_shape_component_module_default()).cards,
                    children: carShapes.map((carShape)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(shop_by_shape_card, {
                            ...carShape
                        }, carShape.title))
                })
            })
        ]
    });
};
/* harmony default export */ var shop_by_shape_component = (ShopByShape);

// EXTERNAL MODULE: ../../../node_modules/react-final-form/dist/react-final-form.es.js + 5 modules
var react_final_form_es = __webpack_require__(51080);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/part-ex/field-wrapper/field-wrapper.component.tsx


// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FieldWrapper = ({ name , onBlur , onClick , ...props })=>{
    const blurable = props.type !== "checkbox" && props.type !== "radio";
    const wrappedOnClick = (e)=>{
        if (onClick) onClick(e);
        if (!blurable) {
            return name;
        }
        return;
    };
    const wrappedOnBlur = (e)=>{
        if (onBlur) onBlur(e);
        if (e.target && blurable) {
            return name;
        }
        return;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
        name: name,
        onBlur: wrappedOnBlur,
        onClick: wrappedOnClick,
        ...props
    });
};
/* harmony default export */ var field_wrapper_component = (FieldWrapper);

// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/part-ex/part-ex.module.css
var part_ex_module = __webpack_require__(38770);
var part_ex_module_default = /*#__PURE__*/__webpack_require__.n(part_ex_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/part-ex/text-field-wrapper/text-field-wrapper.component.tsx


const TextFieldWrapper = ({ errorDisplay ="realtime" , input , meta , onBlur , tooltip , label , inputRef , ...rest })=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TextField */.nv, {
        ...rest,
        label: label,
        id: rest["id"],
        name: input.name,
        type: input.type ? input.type : "text",
        value: input.value,
        onChange: input.onChange,
        onBlur: (e)=>{
            input.onBlur(e);
            if (onBlur) onBlur(e);
        },
        onFocus: input.onFocus,
        ref: inputRef
    });
/* harmony default export */ var text_field_wrapper_component = (TextFieldWrapper);

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/part-ex/part-ex.tsx










const sanitiseVrm = (vrm)=>vrm.replace(/\s/g, "");
const partExchangeCalculatorId = "part-exchange-calculator";
const partExchangeContentPageUrl = "/part-exchange";
const partExchangeCalculatorUrl = "/part-exchange/calculator";
const PartExchangeSection = ({ title , subtitle , placeholder , label , image , link , ctaText  })=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const onCtaClick = (0,react.useCallback)((formData)=>{
        const sanitisedVrm = sanitiseVrm(formData.vrm);
        const label = "part-exchange-calculator";
        trackEvent({
            eventName: label,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: "click",
                    category: "button",
                    label,
                    action: "search"
                }
            }
        });
        window.location.href = `${partExchangeCalculatorUrl}?vrm=${sanitisedVrm}`;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Wrapper */.im, {
        className: {
            container: (part_ex_module_default()).container
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                id: partExchangeCalculatorId,
                className: (part_ex_module_default()).partExchangeMarketingSectionContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: partExchangeCalculatorId,
                    className: (part_ex_module_default()).partExchangeMarketingSectionWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (part_ex_module_default()).partExchangeMarketingSectionLeftSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (part_ex_module_default()).partExchangeMarketingSectionContent,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        element: "h2",
                                        type: "vehiclePrice",
                                        className: (part_ex_module_default()).partExchangeMarketingSectionTitle,
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        element: "h3",
                                        type: "vehicleSubTitle",
                                        className: (part_ex_module_default()).partExchangeMarketingSectionSubTitle,
                                        children: subtitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
                                        onSubmit: (formData)=>onCtaClick(formData),
                                        render: ({ handleSubmit  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                                onSubmit: handleSubmit,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (part_ex_module_default()).vrmInputWrapper,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(field_wrapper_component, {
                                                            id: "vrmInput",
                                                            name: "vrm",
                                                            required: true,
                                                            component: text_field_wrapper_component,
                                                            fullWidth: true,
                                                            "aria-label": label,
                                                            classNames: {
                                                                label: {
                                                                    label: (part_ex_module_default()).vrmInputLabel
                                                                },
                                                                input: (part_ex_module_default()).vrmInput
                                                            },
                                                            label: label,
                                                            placeholder: placeholder,
                                                            maxLength: 10
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Secondary */.T7, {
                                                            type: "submit",
                                                            variant: "alternative",
                                                            href: "",
                                                            children: ctaText
                                                        })
                                                    ]
                                                })
                                            })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (part_ex_module_default()).partExchangeMarketingSectionImage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: image.filename,
                                alt: image.alt ?? "",
                                layout: "responsive",
                                width: 410,
                                height: 362
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (part_ex_module_default()).infoWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    href: "/part-exchange",
                    className: (part_ex_module_default()).findMore,
                    "data-testid": "part-exchange-button",
                    onClick: ()=>{
                        trackEvent({
                            eventName: `Home page marketing block CTA`,
                            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
                            data: {
                                event: {
                                    name: "click",
                                    category: "button",
                                    label: `Home page marketing block CTA`,
                                    action: "navigate to part-exchange"
                                }
                            }
                        });
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                            name: "info",
                            height: 20,
                            color: "toreaBay"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (part_ex_module_default()).findMoreButton,
                            children: link
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var part_ex = (PartExchangeSection);

// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/why-cinch/why-cinch.module.css
var why_cinch_module = __webpack_require__(83411);
var why_cinch_module_default = /*#__PURE__*/__webpack_require__.n(why_cinch_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/why-cinch/why-cinch.tsx






const WhyCinch = ({ image , title , cards  })=>{
    const { vw  } = (0,util_src/* useViewport */.Sj)({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isMobile = vw < 1024;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (why_cinch_module_default()).whyCinchContainer,
        "data-testid": "whycinch",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (why_cinch_module_default()).whyCinchInner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                    fontSize: "h1",
                    className: (why_cinch_module_default()).whyCinchHeading,
                    children: [
                        title,
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (why_cinch_module_default()).contentWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CustomList */.SP, {
                            customClassNames: {
                                bulletContainer: (why_cinch_module_default()).bulletContainer,
                                listItem: (why_cinch_module_default()).listItem
                            },
                            children: cards.map((card)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CustomListItem */.DF, {
                                    bullet: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CardWithIcon */.B3, {
                                        className: (why_cinch_module_default()).cardWithIcon,
                                        iconName: card.icon,
                                        iconColor: "vividViolet",
                                        iconSize: 37
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ContentSection */.IH, {
                                        title: card.title,
                                        classNames: {
                                            title: (why_cinch_module_default()).contentSectionTitle,
                                            body: (why_cinch_module_default()).contentSectionBody
                                        },
                                        sectionWrapperClass: (why_cinch_module_default()).contentSectionWrapper,
                                        children: (0,shared_src/* renderWithResolver */.be)(card.body)
                                    })
                                }, card.name))
                        }),
                        !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (why_cinch_module_default()).whyCinchImageContainer,
                            "data-testid": "featured-cards-image-section",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,src/* getStoryblokImageServiceUrl */.Vb)(image.filename, {
                                    width: 360,
                                    height: 414,
                                    filters: [
                                        {
                                            quality: 80
                                        }
                                    ]
                                }),
                                alt: image.alt ?? ""
                            })
                        }) : null
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var why_cinch = (WhyCinch);

// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/our-commitment/slides/our-commitment-slide.module.css
var our_commitment_slide_module = __webpack_require__(57613);
var our_commitment_slide_module_default = /*#__PURE__*/__webpack_require__.n(our_commitment_slide_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/our-commitment/slides/our-commitment-slide.tsx




const OurCommitmentSlide = ({ iconName , backgroundColor , title , body  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            backgroundColor
        },
        className: (our_commitment_slide_module_default()).ourCommitmentSlideContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ContentSectionWithIcon */.$n, {
            sectionWrapperClass: (our_commitment_slide_module_default()).ourCommitmentSlide,
            iconName: iconName,
            iconColor: "goGreen",
            title: title,
            classNames: {
                title: (our_commitment_slide_module_default()).title,
                body: (our_commitment_slide_module_default()).body
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                dangerouslySetInnerHTML: {
                    __html: body
                }
            })
        })
    });
/* harmony default export */ var our_commitment_slide = (OurCommitmentSlide);

// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/our-commitment/carousel/our-commitment-carousel.module.css
var our_commitment_carousel_module = __webpack_require__(48918);
var our_commitment_carousel_module_default = /*#__PURE__*/__webpack_require__.n(our_commitment_carousel_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/our-commitment/carousel/our-commitment-carousel.tsx





const OurCommitmentCarousel = ({ slides  })=>{
    const backgroundColors = [
        "#8C32BE",
        "#5234B6",
        "#311C77"
    ];
    const carouselName = "cinch-commitment";
    const navAriaLabels = {
        previous: "Go to previous slide",
        next: "Go to next slide"
    };
    const navCustomClasses = {
        prevButton: (our_commitment_carousel_module_default()).prevButton,
        nextButton: (our_commitment_carousel_module_default()).nextButton
    };
    const swiperSettings = {
        loop: true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "ourCommitment",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Carousel */.lr, {
                name: carouselName,
                swiperSettings: swiperSettings,
                children: slides.map((slide, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselSlide */.qs, {
                        children: /*#__PURE__*/ (0,react.createElement)(our_commitment_slide, {
                            ...slide,
                            key: slide.title,
                            backgroundColor: backgroundColors[idx % backgroundColors.length]
                        })
                    }, idx))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* CarouselControls */.J8, {
                customClassNames: (our_commitment_carousel_module_default()).controlsWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselPagination */.Jj, {
                        name: carouselName,
                        customClassNames: (our_commitment_carousel_module_default()).customPagination
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselNavigation */.Pn, {
                        name: carouselName,
                        ariaLabels: navAriaLabels,
                        customClassNames: navCustomClasses
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var our_commitment_carousel = (OurCommitmentCarousel);

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/assets/logo-full.webuyanycar.svg
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SvgLogoFullwebuyanycar = props => /*#__PURE__*/react.createElement("svg", _extends({
  viewBox: "0 0 343 121",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M172.808 81.17h23.547c.36 0 .687.263.72.624a5.385 5.385 0 0 0 5.33 4.531c2.649 0 4.873-1.904 5.298-4.53a.737.737 0 0 1 .72-.625h9.876v-4.99c0-3.58-7.979-5.55-14.814-6.108-.131 0-.229-.066-.327-.132l-10.956-7.06h-26.72l-.163.033c-.818.198-10.269 2.824-12.558 10.574-.589 2.003-.426 3.677.523 4.958 1.766 2.397 5.821 2.725 7.456 2.758a.74.74 0 0 1 .72.591 5.4 5.4 0 0 0 5.298 4.4c2.584 0 4.807-1.872 5.298-4.4a.77.77 0 0 1 .752-.624Z",
  fill: "#1E8DCE"
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M202.405 87.836a6.876 6.876 0 0 1-6.671-5.155h-22.337c-.85 2.922-3.532 5.023-6.606 5.023-3.107 0-5.789-2.068-6.639-5.023-2.388-.099-6.116-.723-8.046-3.317-1.242-1.675-1.504-3.776-.784-6.272 2.583-8.734 13.212-11.492 13.67-11.59.033 0 .065 0 .098-.033l.262-.033h27.079c.13 0 .294.033.392.131l10.989 7.06c4.971.427 15.992 2.036 15.992 7.585v5.746a.742.742 0 0 1-.752.755h-10.008a6.874 6.874 0 0 1-6.639 5.123Zm-29.597-6.666h23.547c.36 0 .687.263.72.624a5.385 5.385 0 0 0 5.33 4.531c2.649 0 4.873-1.904 5.298-4.531a.737.737 0 0 1 .72-.624h9.876v-4.99c0-3.58-7.979-5.55-14.814-6.108-.131 0-.229-.066-.327-.132l-10.956-7.06h-26.72l-.163.033c-.818.197-10.269 2.824-12.558 10.574-.589 2.003-.426 3.677.523 4.958 1.766 2.397 5.821 2.725 7.456 2.758a.74.74 0 0 1 .72.591 5.4 5.4 0 0 0 5.298 4.4c2.584 0 4.807-1.872 5.298-4.4a.77.77 0 0 1 .752-.624Z",
  fill: "#000"
})), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
  d: "M177.648 71.418c15.24 5.55 29.892 7.618 40.684 6.436v-1.675c0-3.579-7.98-5.55-14.815-6.107-.131 0-.229-.066-.327-.132l-10.956-7.06h-26.752l-.163.033c-.294.066-1.799.493-3.696 1.38 4.873 2.626 10.269 5.023 16.025 7.125Z",
  fill: "#5EB1E3"
})), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
  d: "M94.744 81.105c.032 0 .032 0 0 0l22.565.032c.36 0 .687.263.72.624.163 1.117.687 2.135 1.504 2.956 1.014 1.017 2.388 1.576 3.827 1.609 2.649 0 4.873-1.905 5.33-4.532a.737.737 0 0 1 .72-.624l9.844.033.033-.295c.196-3.021-.556-5.451-2.224-7.29-2.944-3.152-7.915-3.645-10.629-3.645-.393 0-.752 0-.981.033-.197 0-.425-.066-.556-.197-3.663-3.579-8.667-7.42-11.806-7.454H97.556c-5.821 0-10.138 5.221-11.348 6.83-.131.197-.36.296-.621.296-5.626-.066-9.42 1.28-11.283 3.973-2.257 3.25-.785 7.224-.72 7.388l.066.197h9.55c.359 0 .686.263.719.624.425 2.463 2.518 4.269 5.036 4.269a5.09 5.09 0 0 0 5.004-4.236c.13-.329.425-.591.785-.591Z",
  fill: "#E41517"
})), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
  d: "M123.392 87.836c-1.864 0-3.597-.722-4.873-2.036a6.794 6.794 0 0 1-1.798-3.152l-21.356-.033c-.785 2.857-3.368 4.86-6.345 4.86-3.008 0-5.592-2.036-6.377-4.893h-9.451a.738.738 0 0 1-.687-.492l-.262-.69c-.065-.197-1.798-4.893.883-8.767 2.093-3.054 6.181-4.597 12.133-4.597h.033C86.862 66 91.44 60.91 97.59 60.91h15.534c4.35 0 10.498 5.583 12.624 7.651h.72c2.943 0 8.404.526 11.708 4.105 1.995 2.134 2.878 4.958 2.616 8.406l-.066.985a.75.75 0 0 1-.752.69l-9.942-.034a6.874 6.874 0 0 1-6.639 5.123Zm-28.648-6.731c.032 0 .032 0 0 0l22.565.032c.36 0 .687.263.72.624.163 1.117.687 2.135 1.504 2.956 1.014 1.017 2.388 1.576 3.827 1.608 2.649 0 4.873-1.904 5.33-4.53a.737.737 0 0 1 .72-.625l9.844.033.033-.296c.196-3.02-.556-5.45-2.224-7.289-2.944-3.152-7.915-3.645-10.629-3.645-.393 0-.752 0-.981.033-.197 0-.425-.066-.556-.197-3.663-3.58-8.667-7.42-11.806-7.454H97.556c-5.821 0-10.138 5.221-11.348 6.83-.131.197-.36.296-.621.296-5.626-.066-9.42 1.28-11.283 3.973-2.257 3.25-.785 7.224-.72 7.388l.066.197h9.55c.359 0 .686.263.719.624.425 2.462 2.518 4.268 5.036 4.268a5.09 5.09 0 0 0 5.004-4.235c.13-.329.425-.591.785-.591Z",
  fill: "#000"
})), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
  d: "M102.396 71.746c14.161 5.156 27.635 7.159 36.76 6.075-.327-1.642-1.014-3.054-2.061-4.203-2.943-3.152-7.914-3.645-10.628-3.645-.393 0-.753 0-.982.033-.196 0-.425-.066-.556-.197-3.662-3.579-8.666-7.42-11.806-7.454H97.589c-3.434 0-6.345 1.84-8.405 3.645 4.023 2.069 8.47 4.006 13.212 5.746Z",
  fill: "#EE745A"
})), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
  d: "M307.385 81.663h17.399a.84.84 0 0 1 .817.69c.327 2.265 2.29 4.005 4.612 4.005 2.289 0 4.251-1.707 4.578-4.006a.816.816 0 0 1 .818-.69c1.341 0 3.761-.23 5.004-1.674.621-.722.883-1.707.719-2.824l-.458-3.185c-.327-2.233-2.06-3.743-4.284-3.743h-3.565a.741.741 0 0 1-.523-.197l-11.087-9.917h-24.364l-.196.033c-.491.164-4.415 1.708-5.364 9.851-.621 5.254-.163 8.8 1.374 10.475.686.788 1.635 1.182 2.747 1.182h1.079c.393 0 .752.295.818.69.327 2.265 2.289 4.005 4.578 4.005 2.29 0 4.252-1.707 4.579-4.006-.033-.394.327-.69.719-.69Z",
  fill: "#FBBA00"
})), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
  d: "M330.18 87.836c-2.813 0-5.265-1.97-5.952-4.663h-16.287c-.687 2.693-3.107 4.663-5.952 4.663-2.812 0-5.265-1.97-5.952-4.663h-.523c-1.537 0-2.878-.59-3.859-1.707-1.832-2.069-2.388-5.878-1.734-11.657.458-3.907 1.636-6.928 3.467-8.997 1.472-1.642 2.845-2.069 3.009-2.102.032 0 .065 0 .098-.032l.294-.033h24.79c.196 0 .36.065.49.197l11.12 9.916h3.303c2.976 0 5.298 2.003 5.756 4.991l.458 3.185c.229 1.576-.131 2.956-1.047 4.04-1.472 1.707-3.924 2.1-5.592 2.166a6.06 6.06 0 0 1-5.887 4.696Zm-22.86-6.173h17.497a.77.77 0 0 1 .752.656c.327 2.299 2.289 4.04 4.611 4.04 2.322 0 4.284-1.741 4.611-4.04.066-.36.36-.656.752-.656h.066c1.341 0 3.761-.23 5.004-1.675.621-.722.883-1.707.719-2.824l-.458-3.185c-.327-2.233-2.06-3.743-4.284-3.743h-3.597a.664.664 0 0 1-.491-.197l-11.119-9.917h-24.365l-.196.033c-.491.164-4.415 1.708-5.364 9.851-.621 5.254-.163 8.8 1.374 10.475.687.788 1.635 1.182 2.747 1.182h1.145c.36 0 .687.262.752.656.327 2.299 2.289 4.04 4.611 4.04 2.29 0 4.284-1.741 4.611-4.04-.065-.394.262-.656.622-.656Z",
  fill: "#000"
})), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
  d: "m341.299 77.164-.458-3.185c-.327-2.233-2.06-3.743-4.284-3.743h-3.597a.666.666 0 0 1-.491-.197l-11.119-9.917h-24.365l-.196.033c-.065.033-.261.099-.49.197 5.527 5.024 13.768 9.884 23.547 13.43 7.587 2.758 15.011 4.335 21.421 4.761.098-.427.098-.886.032-1.379Z",
  fill: "#FED76D"
})), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
  d: "M6.181 61.896c-1.602 0-2.91 1.576-3.826 4.695-.916 3.12-.916 5.45.032 6.732.426.59 1.047.952 1.8 1.05.326.033.555.296.62.624.099.591.164 1.51.164 2.693 0 2.594 2.91 3.283 5.364 3.382.326.032.62.262.686.59.556 2.726 2.976 4.696 5.723 4.696 2.78 0 5.233-2.068 5.756-4.827a.736.736 0 0 1 .72-.624c4.186.033 9.255.033 13.9.033.359 0 .653.23.719.591.588 2.66 2.976 4.597 5.69 4.597 2.747 0 5.135-1.97 5.723-4.662.066-.329.36-.591.687-.591.196 0 .36 0 .458-.033 3.14-.329 6.933-1.15 7.195-3.382.294-2.627.032-4.4-.752-5.287-.262-.295-.556-.492-.916-.558-.294-.066-.49-.295-.556-.591-.196-1.182-.752-2.758-2.224-3.415-1.537-.69-5.952-1.313-9.582-1.675-.131 0-.262-.065-.393-.164-.327-.263-1.079-.985-2.485-2.856-2.06-2.759-5.167-5.484-5.527-5.78l-.098-.065h-20.8c-1.276 0-3.467 1.871-5.821 4.99-.23.296-.622.395-.949.198a2.613 2.613 0 0 0-1.308-.361Z",
  fill: "#60519D"
})), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
  d: "M16.744 87.836c-3.27 0-6.148-2.2-7.03-5.32-5.397-.426-6.247-3.218-6.247-4.86 0-.886-.033-1.51-.066-1.937a3.983 3.983 0 0 1-2.19-1.51c-1.276-1.708-1.342-4.4-.263-8.045 1.145-3.842 2.911-5.779 5.266-5.779.49 0 .98.099 1.471.296 1.897-2.43 4.48-5.123 6.64-5.123h21.06c.164 0 .36.066.491.164l.295.263c.36.328 3.564 3.12 5.723 6.01 1.112 1.477 1.766 2.166 2.06 2.429 2.453.263 7.816.854 9.811 1.773 1.963.854 2.715 2.791 3.01 4.105.457.197.85.492 1.21.853 1.111 1.248 1.47 3.35 1.144 6.436-.294 2.594-3.14 4.17-8.503 4.728-.916 3.087-3.761 5.287-7.032 5.287-3.205 0-6.05-2.134-6.998-5.188-4.252 0-8.863-.033-12.755-.033-.883 3.185-3.76 5.45-7.097 5.45ZM6.181 61.896c-1.602 0-2.91 1.576-3.826 4.695-.916 3.12-.916 5.45.032 6.731.426.591 1.047.953 1.8 1.051.326.033.555.296.62.624.099.591.164 1.51.164 2.693 0 2.594 2.91 3.283 5.364 3.382.326.032.62.262.686.59.556 2.726 2.976 4.696 5.723 4.696 2.78 0 5.233-2.068 5.756-4.827a.736.736 0 0 1 .72-.624c4.186.033 9.255.033 13.9.033.359 0 .653.23.719.591.588 2.66 2.976 4.597 5.69 4.597 2.747 0 5.135-1.97 5.723-4.662.066-.329.36-.591.687-.591.196 0 .36 0 .458-.033 3.14-.329 6.933-1.15 7.195-3.382.294-2.627.032-4.4-.752-5.287-.262-.295-.556-.492-.916-.558-.294-.066-.49-.296-.556-.591-.196-1.182-.752-2.758-2.224-3.415-1.537-.69-5.952-1.313-9.582-1.675-.131 0-.262-.065-.393-.164-.327-.263-1.079-.985-2.485-2.856-2.06-2.759-5.167-5.484-5.527-5.78l-.098-.065h-20.8c-1.276 0-3.467 1.871-5.821 4.99-.23.296-.622.395-.949.198a2.614 2.614 0 0 0-1.308-.361Z",
  fill: "#000"
})), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
  d: "M57.624 77.493v-.066c.295-2.627.033-4.4-.752-5.287-.261-.295-.556-.492-.915-.558-.295-.066-.491-.295-.556-.59-.197-1.183-.753-2.76-2.224-3.416-1.537-.69-5.952-1.313-9.583-1.674-.13 0-.261-.066-.392-.165-.327-.262-1.08-.985-2.485-2.856-2.06-2.758-5.168-5.484-5.527-5.78l-.099-.065h-20.8c-1.111 0-2.91 1.412-4.938 3.874 5.43 4.4 12.918 8.603 21.585 11.756 9.779 3.579 19.23 5.155 26.686 4.827Z",
  fill: "#847AB6"
})), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
  d: "M272.163 82.418c-.327.033-.589.23-.687.525-.588 1.97-2.453 3.382-4.513 3.382s-3.924-1.379-4.513-3.349a.737.737 0 0 0-.72-.525h-13.179a.779.779 0 0 0-.72.525c-.588 1.97-2.453 3.35-4.513 3.35a4.732 4.732 0 0 1-4.513-3.383c-.098-.295-.36-.525-.687-.525-5.2-.296-5.592-3.284-5.592-4.17 0-5.714 6.344-6.666 7.097-6.732.228-.032.425-.13.523-.328 1.21-1.806 5.821-7.684 15.011-7.684s13.801 5.878 15.011 7.684a.764.764 0 0 0 .523.328c.72.099 7.097 1.018 7.097 6.732 0 .92-.425 3.907-5.625 4.17Z",
  fill: "#ED6EA7"
})), _path14 || (_path14 = /*#__PURE__*/react.createElement("path", {
  d: "M271.215 70.072c-1.57-2.233-6.574-8.078-16.058-8.078s-14.488 5.845-16.058 8.078c-5.952.853-8.045 4.925-8.045 8.176 0 .853.327 5.09 6.508 5.647.916 2.332 3.238 3.94 5.789 3.94 2.518 0 4.807-1.575 5.756-3.874h12.166c.948 2.299 3.237 3.875 5.755 3.875 2.551 0 4.841-1.61 5.789-3.94 6.181-.559 6.508-4.762 6.508-5.648-.065-3.251-2.191-7.323-8.11-8.176Zm.948 12.346c-.327.033-.589.23-.687.525-.588 1.97-2.453 3.382-4.513 3.382s-3.924-1.379-4.513-3.349a.737.737 0 0 0-.72-.525h-13.179a.779.779 0 0 0-.72.525c-.588 1.97-2.453 3.35-4.513 3.35a4.732 4.732 0 0 1-4.513-3.383c-.098-.295-.36-.525-.687-.525-5.2-.296-5.592-3.284-5.592-4.17 0-5.714 6.344-6.666 7.097-6.732.228-.032.425-.13.523-.328 1.21-1.806 5.821-7.684 15.011-7.684s13.801 5.878 15.011 7.684a.763.763 0 0 0 .523.328c.72.099 7.097 1.018 7.097 6.732 0 .92-.425 3.907-5.625 4.17Z",
  fill: "#000"
})), _path15 || (_path15 = /*#__PURE__*/react.createElement("path", {
  d: "M270.691 71.516c-.229-.032-.425-.13-.523-.328-1.21-1.806-5.821-7.684-15.011-7.684-6.05 0-10.138 2.562-12.558 4.827a87.666 87.666 0 0 0 12.721 5.812c7.98 2.923 15.764 4.499 22.403 4.794.065-.295.065-.525.065-.69 0-5.713-6.377-6.632-7.097-6.73Z",
  fill: "#F08AB7"
})), _path16 || (_path16 = /*#__PURE__*/react.createElement("path", {
  d: "M41.174 12.38c-1.013 0-1.831.262-2.42.754-.556.493-.948 1.018-1.177 1.642-.196.558-.458 1.412-.785 2.627l-4.186 14.316-3.761-13.167c-.458-1.576-.818-2.627-1.08-3.283-.294-.723-.784-1.38-1.471-1.97-.72-.624-1.733-.953-2.976-.953-1.21 0-2.191.329-2.943.953-.687.59-1.178 1.247-1.44 1.904-.228.624-.588 1.74-1.046 3.316l-3.695 13.2-4.187-14.316c-.49-1.74-.98-2.955-1.439-3.678-.556-.886-1.57-1.313-2.976-1.313-1.079 0-1.995.394-2.747 1.116-.752.756-1.112 1.61-1.112 2.562 0 .69.295 1.904.916 3.611l5.92 17.568c.163.46.392 1.116.686 1.904.295.821.654 1.576 1.047 2.2a4.598 4.598 0 0 0 1.635 1.544c.654.36 1.439.558 2.355.558 1.798 0 3.074-.624 3.826-1.806.654-1.051 1.276-2.627 1.799-4.663l3.466-12.215 3.565 12.215c.36 1.313.687 2.364 1.014 3.185a5.884 5.884 0 0 0 1.57 2.299c.752.656 1.766.985 3.009.985 1.21 0 2.19-.296 2.943-.92.687-.59 1.21-1.248 1.537-2.003.294-.69.687-1.74 1.21-3.283l5.952-17.567c.589-1.61.883-2.792.883-3.645 0-1.018-.392-1.872-1.145-2.594-.784-.723-1.7-1.084-2.747-1.084ZM72.538 29.454c1.275-.657 1.93-2.069 1.93-4.137 0-2.102-.557-4.17-1.603-6.174-1.08-2.003-2.682-3.677-4.84-4.925-2.126-1.248-4.71-1.905-7.686-1.905-2.257 0-4.35.362-6.214 1.117-1.864.722-3.5 1.806-4.775 3.218a13.815 13.815 0 0 0-2.943 4.99c-.654 1.905-1.014 4.007-1.014 6.24 0 4.76 1.374 8.57 4.088 11.36 2.715 2.792 6.574 4.237 11.414 4.237 2.093 0 4.023-.296 5.658-.854 1.635-.558 3.041-1.28 4.12-2.134 1.112-.854 1.93-1.773 2.486-2.726.556-.985.85-1.871.85-2.627 0-.919-.294-1.674-.915-2.2-.59-.525-1.341-.788-2.224-.788-.85 0-1.537.23-2.028.657-.916.854-1.635 1.51-2.191 2.036-.556.492-1.177.952-1.799 1.346-.621.394-1.275.722-1.93.887-.653.197-1.406.295-2.223.295-1.178 0-2.29-.295-3.27-.886-.982-.591-1.767-1.445-2.355-2.627-.524-1.018-.818-2.2-.916-3.48h13.67c1.962-.034 3.565-.33 4.71-.92Zm-6.476-4.532H54.191c.294-1.97.915-3.513 1.896-4.53 1.047-1.15 2.388-1.708 4.023-1.708 1.766 0 3.107.558 4.186 1.674.949 1.018 1.537 2.561 1.766 4.564Z",
  fill: "#009B3E"
})), _path17 || (_path17 = /*#__PURE__*/react.createElement("path", {
  d: "M101.186 14.218c-1.93-1.215-4.186-1.839-6.737-1.839-2.19 0-4.088.394-5.592 1.215-1.112.591-2.224 1.412-3.303 2.364V6.206c0-1.478-.36-2.66-1.047-3.513-.72-.887-1.766-1.314-3.074-1.314-1.275 0-2.29.46-3.009 1.38-.687.886-1.014 2.134-1.014 3.775v32.048c0 1.543.36 2.725 1.08 3.546.72.854 1.733 1.281 2.943 1.281 1.177 0 2.191-.427 2.976-1.248.621-.657.981-1.576 1.112-2.692.36.394.654.69.948.952.524.492 1.145.952 1.897 1.445.752.46 1.668.853 2.715 1.149 1.046.295 2.158.427 3.336.427 1.93 0 3.728-.394 5.33-1.182a11.627 11.627 0 0 0 4.121-3.35c1.112-1.411 1.962-3.119 2.551-5.023.589-1.905.883-4.04.883-6.305 0-3.086-.523-5.812-1.57-8.078-1.079-2.265-2.616-4.071-4.546-5.286Zm-2.518 13.627c0 2.824-.621 5.024-1.864 6.501-1.21 1.478-2.616 2.168-4.284 2.168-1.995 0-3.565-.69-4.775-2.135-1.243-1.445-1.864-3.579-1.864-6.337 0-1.905.294-3.546.883-4.893.589-1.313 1.373-2.364 2.355-3.053.98-.69 2.093-1.018 3.368-1.018 1.243 0 2.29.328 3.205 1.018.916.69 1.635 1.674 2.159 2.955.555 1.346.817 2.955.817 4.794ZM136.049 13.66c-.785-.854-1.832-1.28-3.074-1.28-1.276 0-2.322.426-3.107 1.313-.785.853-1.178 2.101-1.178 3.71v8.931c0 4.236-.294 5.944-.556 6.567a5.918 5.918 0 0 1-2.158 2.595c-.981.656-2.028.985-3.14.985s-1.995-.263-2.616-.821c-.654-.558-1.079-1.346-1.341-2.397-.261-1.117-.425-2.496-.425-4.138V17.37c0-1.609-.392-2.857-1.177-3.71-.785-.854-1.864-1.314-3.14-1.314-1.275 0-2.289.427-3.074 1.28-.752.822-1.145 2.102-1.145 3.711v14.547c0 3.02.491 5.385 1.472 7.026.818 1.38 1.995 2.496 3.499 3.284 1.472.788 3.173 1.182 5.037 1.182 1.504 0 2.91-.197 4.088-.59a11.06 11.06 0 0 0 3.368-1.774 16.6 16.6 0 0 0 1.799-1.642c.098 1.15.491 2.069 1.112 2.758.785.854 1.766 1.281 2.943 1.281 1.178 0 2.159-.427 2.911-1.248.752-.82 1.112-2.003 1.112-3.579V17.337c-.033-1.576-.425-2.823-1.21-3.677ZM166.006 12.905a3.602 3.602 0 0 0-1.897-.526c-.883 0-1.603.164-2.126.493-.523.328-.981.92-1.406 1.806-.393.788-.818 1.904-1.276 3.283l-5.265 15.105-5.592-16.353c-.426-1.313-.949-2.364-1.537-3.086-.655-.821-1.636-1.248-2.878-1.248-.72 0-1.407.197-2.061.558-.654.394-1.177.887-1.537 1.51a3.811 3.811 0 0 0-.589 2.07c0 .689.295 1.707.883 3.086l8.896 22.525-.556 1.412c-.491 1.215-.916 2.069-1.275 2.66-.327.525-.687.887-1.047 1.084-.556.295-1.374.492-2.747.164a4.516 4.516 0 0 0-1.308-.197c-1.145 0-2.061.295-2.682.854-.654.59-.981 1.379-.981 2.397 0 1.477.687 2.56 1.995 3.119 1.144.492 2.812.755 5.069.755 2.289 0 4.153-.361 5.527-1.083 1.406-.723 2.518-1.773 3.368-3.12.818-1.28 1.636-3.086 2.453-5.286l9.55-25.087c.229-.657.425-1.313.621-1.97.164-.624.262-1.116.36-1.61a3.81 3.81 0 0 0-.491-1.87c-.392-.625-.85-1.117-1.471-1.445Z",
  fill: "#010202"
})), _path18 || (_path18 = /*#__PURE__*/react.createElement("path", {
  d: "M196.257 32.639c.033-1.478.033-2.791.033-4.006v-4.367c0-2.791-.393-5.09-1.21-6.83-.818-1.773-2.257-3.12-4.219-3.94-1.897-.789-4.546-1.183-7.816-1.183-2.944 0-5.462.427-7.457 1.215-2.028.821-3.532 1.905-4.513 3.218-.981 1.314-1.505 2.693-1.505 4.138 0 1.017.36 1.838 1.112 2.495.72.624 1.57.952 2.551.952 1.112 0 1.864-.23 2.257-.722.294-.361.785-1.05 1.472-2.102.621-.952 1.34-1.641 2.191-2.101.85-.46 2.158-.69 3.892-.69 1.962 0 3.237.362 3.793 1.117.556.722.883 1.872 1.014 3.382a64.944 64.944 0 0 1-3.761.985c-1.308.328-2.878.657-4.709 1.018-1.832.361-3.009.624-3.467.722-2.322.526-4.219 1.544-5.56 3.054-1.373 1.543-2.06 3.415-2.06 5.55 0 1.608.425 3.086 1.243 4.465.817 1.38 2.027 2.463 3.532 3.25 1.504.789 3.27 1.183 5.232 1.183 2.126 0 4.088-.361 5.789-1.084 1.537-.624 3.107-1.576 4.742-2.758.72 1.117 1.406 1.97 2.06 2.627 1.832 1.74 3.925 1.478 5.462.164.85-.722 1.276-1.576 1.276-2.528 0-.329-.066-.985-.72-3.087-.425-1.445-.654-2.857-.654-4.137Zm-8.372-3.743v.197c0 2.43-.295 4.17-.916 5.188-.523.886-1.341 1.641-2.453 2.2-1.112.59-2.387.886-3.728.886-1.21 0-2.159-.328-2.878-1.018-.72-.656-1.047-1.444-1.047-2.397 0-.886.262-1.576.851-2.035.654-.526 1.308-.92 1.995-1.084.785-.197 2.224-.525 4.219-.952 1.635-.329 2.943-.657 3.957-.985ZM227.293 20.62c-.163-1.116-.49-2.166-.981-3.086-.818-1.641-2.028-2.955-3.663-3.841-1.602-.887-3.434-1.347-5.461-1.347-2.061 0-3.958.427-5.56 1.28-1.178.625-2.322 1.511-3.336 2.628a4.876 4.876 0 0 0-.491-1.74 3.985 3.985 0 0 0-1.471-1.642 4.04 4.04 0 0 0-2.061-.559c-1.242 0-2.223.427-2.943 1.248-.719.821-1.079 2.003-1.079 3.547v21.211c0 1.577.392 2.824 1.177 3.71.785.92 1.832 1.38 3.074 1.38 1.276 0 2.322-.427 3.107-1.313.785-.854 1.21-2.135 1.21-3.777v-9.194c0-2.922.164-4.925.491-5.91.458-1.248 1.177-2.233 2.126-2.922.981-.69 2.027-1.051 3.205-1.051 1.766 0 2.91.525 3.466 1.576.622 1.182.949 2.955.949 5.254v12.215c0 1.576.392 2.824 1.177 3.71.785.92 1.831 1.38 3.107 1.38 1.243 0 2.289-.46 3.074-1.347.785-.854 1.145-2.134 1.145-3.743V24.693a41.83 41.83 0 0 0-.262-4.072ZM235.306 54.343c2.289 0 4.153-.36 5.527-1.083 1.406-.723 2.518-1.773 3.368-3.12.818-1.28 1.635-3.086 2.453-5.286l9.549-25.087c.229-.657.426-1.313.622-1.97.163-.657.294-1.15.36-1.609 0-.657-.164-1.313-.491-1.904a3.966 3.966 0 0 0-1.406-1.445 3.603 3.603 0 0 0-1.897-.526c-.883 0-1.603.165-2.126.493-.523.328-.981.92-1.406 1.806-.393.82-.818 1.905-1.276 3.284L243.318 33l-5.625-16.352c-.425-1.346-.948-2.364-1.537-3.087-.654-.82-1.603-1.248-2.878-1.248-.72 0-1.406.197-2.06.559a4.327 4.327 0 0 0-1.57 1.51 4.078 4.078 0 0 0-.556 2.069c0 .69.294 1.707.883 3.086l8.928 22.526-.589 1.412c-.49 1.182-.915 2.068-1.275 2.627-.327.525-.687.886-1.047 1.083-.556.296-1.439.46-2.747.164a4.516 4.516 0 0 0-1.308-.197c-1.145 0-2.06.296-2.682.854-.654.591-.981 1.38-.981 2.397 0 1.478.687 2.561 1.995 3.12 1.145.492 2.845.755 5.004.755h.033v.065Z",
  fill: "#009B3E"
})), _path19 || (_path19 = /*#__PURE__*/react.createElement("path", {
  d: "M282.857 29.88c-.915 0-1.7.296-2.322.854-.588.526-1.112 1.215-1.57 2.102-.752 1.313-1.602 2.266-2.583 2.89-.949.623-2.093.919-3.434.919-.981 0-1.93-.197-2.747-.591a5.168 5.168 0 0 1-2.093-1.675c-.589-.755-1.047-1.674-1.374-2.725-.327-1.117-.49-2.332-.49-3.612 0-2.791.621-4.991 1.831-6.567 1.21-1.544 2.747-2.299 4.742-2.299 1.374 0 2.486.296 3.369.92.915.623 1.798 1.608 2.649 2.922.523.755 1.013 1.28 1.471 1.642.524.394 1.145.59 1.897.59 1.079 0 2.028-.36 2.78-1.083.785-.722 1.177-1.642 1.177-2.692 0-.985-.327-2.003-.948-3.087-.621-1.05-1.504-2.069-2.649-2.988-1.145-.92-2.551-1.675-4.219-2.233-1.635-.59-3.467-.854-5.429-.854-3.139 0-5.919.657-8.176 1.97-2.289 1.314-4.088 3.219-5.298 5.616s-1.799 5.188-1.799 8.274c0 4.597 1.341 8.308 3.99 11.066 2.649 2.758 6.345 4.17 11.022 4.17 2.191 0 4.186-.295 5.919-.887 1.766-.59 3.238-1.411 4.415-2.397 1.177-.985 2.06-2.068 2.649-3.152.589-1.116.883-2.2.883-3.218 0-.92-.36-1.773-1.046-2.594-.622-.854-1.538-1.28-2.617-1.28ZM316.412 32.508c.032-1.445.032-2.726.032-3.908v-4.4c0-2.791-.392-5.09-1.21-6.83-.817-1.806-2.256-3.12-4.219-3.94-1.896-.788-4.545-1.182-7.816-1.182-2.943 0-5.461.394-7.424 1.215-2.027.82-3.532 1.904-4.513 3.218-.981 1.313-1.472 2.692-1.472 4.137 0 1.018.36 1.839 1.112 2.495.72.624 1.57.953 2.551.953 1.112 0 1.864-.23 2.257-.723.294-.36.785-1.05 1.472-2.101.621-.952 1.34-1.642 2.191-2.102.85-.46 2.158-.69 3.892-.69 1.962 0 3.237.362 3.793 1.117.556.723.883 1.872 1.014 3.382a65.03 65.03 0 0 1-3.761.985c-1.308.329-2.878.657-4.709 1.018-1.864.361-3.009.624-3.467.723-2.322.525-4.219 1.543-5.56 3.053-1.373 1.51-2.06 3.382-2.06 5.55 0 1.609.425 3.12 1.243 4.465.817 1.38 1.995 2.463 3.532 3.251 1.504.788 3.27 1.182 5.232 1.182 2.126 0 4.088-.361 5.789-1.083 1.537-.624 3.107-1.576 4.742-2.759.72 1.117 1.406 1.97 2.061 2.627 1.798 1.74 3.924 1.51 5.461.132.85-.723 1.276-1.576 1.276-2.529 0-.328-.066-.985-.72-3.086-.523-1.38-.719-2.759-.719-4.17Zm-8.373-3.612v.197c0 2.43-.294 4.17-.915 5.188-.524.886-1.341 1.641-2.453 2.2a8.008 8.008 0 0 1-3.728.886c-1.21 0-2.159-.328-2.878-.985-.72-.657-1.047-1.445-1.047-2.397 0-.886.262-1.543.85-2.036.654-.525 1.309-.92 1.995-1.083.785-.197 2.192-.526 4.219-.953 1.635-.36 2.944-.69 3.957-1.017ZM337.996 20.916c.883 0 1.701-.36 2.42-1.05.753-.723 1.112-1.61 1.112-2.693 0-1.51-.85-2.725-2.485-3.612-1.537-.82-3.14-1.215-4.775-1.215-1.668 0-3.041.427-4.088 1.314-.621.525-1.243 1.248-1.864 2.101-.164-.788-.425-1.444-.785-1.97-.654-.952-1.701-1.412-3.14-1.412-1.896 0-4.186.952-4.186 5.582v20.424c0 1.61.393 2.89 1.178 3.743.785.887 1.831 1.347 3.041 1.347 1.243 0 2.289-.46 3.107-1.314.818-.854 1.21-2.134 1.21-3.776v-6.107c0-2.233.065-4.04.229-5.55.131-1.477.392-2.758.752-3.809.327-.985.785-1.74 1.374-2.232 1.014-.854 2.583-.953 4.742-.23 1.439.394 1.897.46 2.158.46Z",
  fill: "#010202"
})), _path20 || (_path20 = /*#__PURE__*/react.createElement("path", {
  d: "M78.882 115.484c-4.938 0-6.148-3.087-6.148-4.368 0-.591.425-1.641 1.602-1.641 1.243 0 1.537.952 1.864 1.576.426.821.981 1.674 2.65 1.674 1.34 0 2.485-.591 2.485-1.674 0-1.346-1.406-1.708-3.369-2.167-1.7-.427-5.003-1.215-5.003-4.499 0-2.758 2.518-4.203 5.92-4.203 4.676 0 5.493 2.89 5.493 3.579 0 1.018-.588 1.675-1.471 1.675a1.81 1.81 0 0 1-1.505-.821c-.752-1.084-.915-1.313-1.537-1.609-.425-.197-.883-.23-1.21-.23-1.21 0-2.158.46-2.158 1.248 0 .985 1.308 1.313 3.107 1.707.98.23 2.91.821 3.957 1.544.98.722 1.537 2.068 1.537 3.283-.033 2.693-2.028 4.926-6.214 4.926ZM89.773 110.821c.032 1.97 1.602 2.364 2.256 2.364 1.145 0 1.995-.689 2.355-.952.425-.296.85-.657 1.406-.657.752 0 1.341.657 1.341 1.248 0 1.215-1.733 2.66-4.971 2.66-4.48 0-5.952-2.824-5.952-5.582 0-2.332 1.21-5.615 5.658-5.615 4.055 0 5.298 3.053 5.298 4.564 0 .427-.131 1.412-1.145 1.806-.425.164-1.243.197-1.7.197h-4.546v-.033Zm4.022-1.872c.033-1.379-.817-2.364-2.06-2.364-1.734 0-1.93 1.839-1.962 2.364h4.022ZM102.135 112.594c0 1.248 0 1.905-.458 2.364a1.776 1.776 0 0 1-1.276.526c-.457 0-.915-.197-1.275-.526-.458-.459-.458-1.116-.458-2.364v-9.522c0-1.248.033-1.872.458-2.364a1.774 1.774 0 0 1 1.275-.526c.458 0 .916.197 1.276.526.458.459.458 1.116.458 2.364v9.522ZM107.531 112.594c0 1.248 0 1.905-.458 2.364a1.776 1.776 0 0 1-1.275.526c-.458 0-.916-.197-1.276-.526-.458-.459-.458-1.116-.458-2.364v-9.522c0-1.248.033-1.872.458-2.364a1.776 1.776 0 0 1 1.276-.526c.457 0 .915.197 1.275.526.458.459.458 1.116.458 2.364v9.522ZM112.731 112.594c0 1.248-.033 1.905-.458 2.364a1.776 1.776 0 0 1-1.275.526c-.458 0-.916-.197-1.276-.526-.458-.459-.458-1.116-.458-2.364v-5.418c0-1.248 0-1.871.458-2.331.294-.296.752-.558 1.276-.558.359 0 1.471.197 1.7 1.412.098.459.066.623.066 1.477v5.418h-.033Zm-1.733-9.194a1.609 1.609 0 0 1 0-3.218c.883 0 1.602.723 1.602 1.609 0 .887-.719 1.609-1.602 1.609ZM124.864 112.594c0 1.248 0 1.905-.458 2.364-.229.23-.654.526-1.243.526-.457 0-.948-.197-1.308-.526-.458-.459-.458-1.116-.458-2.364v-3.054c0-1.05.033-2.594-1.602-2.594-.654 0-1.472.362-1.799 1.412-.131.394-.131 1.412-.131 1.872v2.364c0 .985.164 2.89-1.766 2.89-1.7 0-1.733-1.478-1.733-2.89v-5.615c0-1.182 0-1.773.425-2.2.295-.263.491-.492 1.21-.492.229 0 1.635.065 1.603 1.904.948-1.248 2.093-1.904 3.63-1.904 1.046 0 2.616.262 3.303 1.97.36.821.36 2.101.36 2.659v3.678h-.033ZM137.357 114.105c0 3.447-.818 5.483-5.527 5.483-1.472 0-2.845-.164-3.99-.854-1.145-.689-1.243-1.346-1.243-1.806 0-.886.753-1.379 1.472-1.379.752 0 1.177.427 1.733 1.018.425.427.916.657 1.864.657 2.159 0 2.192-.952 2.257-2.627.033-.558 0-.821-.033-1.149-.327.46-1.242 1.642-3.172 1.642-2.714 0-4.382-2.332-4.382-5.55 0-2.2.621-3.152 1.144-3.776.851-.985 1.963-1.477 3.271-1.477 2.06 0 3.041 1.313 3.434 1.806.098-.756.131-.854.294-1.084.36-.558.85-.755 1.308-.755.36 0 1.21.131 1.505 1.083.098.362.13.723.13 1.839v6.929h-.065Zm-5.527-1.577c1.177 0 2.093-.985 2.093-2.692 0-1.937-.883-2.923-2.093-2.923-2.028 0-2.028 2.397-2.028 2.89-.032 1.281.425 2.725 2.028 2.725ZM154.657 103.072c.654-2.43.687-2.66 3.304-2.66 1.046 0 1.766.066 2.289.887.294.426.294 1.017.294 2.298v9.161c0 1.182 0 1.773-.425 2.2-.262.263-.654.526-1.21.526-.425 0-.883-.197-1.21-.493-.425-.427-.425-1.051-.425-2.2v-9.03l-2.29 9.03c-.327 1.281-.457 1.905-.948 2.266-.294.23-.719.427-1.243.427-.425 0-.883-.165-1.242-.427-.458-.361-.622-.985-.949-2.266l-2.289-9.03v9.03c0 1.182.033 1.773-.425 2.2-.262.263-.654.525-1.21.525-.426 0-.883-.197-1.21-.492-.426-.427-.426-1.051-.426-2.2v-9.161c0-1.675 0-2.036.556-2.627.524-.558 1.08-.558 2.061-.558 1.57 0 2.027.032 2.583.656.295.296.36.723.72 2.036l1.799 6.896 1.896-6.994ZM168.131 108.522c.589-.131.753-.229 1.014-.328-.032-.919-.098-1.609-1.635-1.609-.687 0-1.635.131-2.093.854-.392.624-.719 1.116-1.537 1.116-.556 0-1.406-.361-1.406-1.247 0-1.084.817-1.905 1.439-2.266.85-.526 1.766-.788 3.564-.788 3.761 0 5.037 1.051 5.037 4.17v2.922c0 .493.033.887.196 1.445.294.952.36.919.36 1.281 0 .689-.687 1.379-1.668 1.379-.949 0-1.374-.591-1.799-1.675-1.21 1.018-2.518 1.675-4.022 1.675-2.715 0-3.663-1.806-3.663-3.152 0-2.266 2.06-2.824 2.878-3.021l3.335-.756Zm-1.079 2.2c-1.079.362-1.635.559-1.635 1.38 0 .591.491 1.247 1.406 1.247.556 0 1.603-.262 2.061-1.215.294-.591.261-1.149.261-1.97-.294.132-1.766.46-2.093.558ZM183.404 115.484c-1.439 0-1.602-1.314-1.602-1.806-.523.656-1.472 1.806-3.434 1.806-2.584 0-4.448-2.233-4.448-5.714 0-3.119 1.537-5.516 4.513-5.516 1.766 0 2.649.886 3.107 1.379v-2.561c0-1.248 0-1.905.458-2.364a1.859 1.859 0 0 1 1.275-.526c.589 0 1.014.296 1.276.558.458.46.458 1.084.458 2.365v9.686c0 1.346-.033 2.693-1.603 2.693Zm-3.99-8.603c-1.896 0-2.027 2.2-2.027 2.955 0 .46.032 2.988 2.027 2.988.393 0 2.159-.131 2.159-2.988 0-.427 0-2.955-2.159-2.955ZM190.076 110.821c.033 1.97 1.602 2.364 2.256 2.364 1.145 0 1.995-.689 2.355-.952.425-.296.85-.657 1.406-.657.753 0 1.341.657 1.341 1.248 0 1.215-1.733 2.66-4.971 2.66-4.48 0-5.952-2.824-5.952-5.582 0-2.332 1.21-5.615 5.658-5.615 4.055 0 5.298 3.053 5.298 4.564 0 .427-.131 1.412-1.145 1.806-.425.164-1.242.197-1.7.197h-4.546v-.033Zm4.055-1.872c.033-1.379-.817-2.364-2.06-2.364-1.733 0-1.93 1.839-1.962 2.364h4.022ZM210.745 115.484c-4.938 0-6.149-3.087-6.149-4.368 0-.591.426-1.641 1.603-1.641 1.243 0 1.537.952 1.864 1.576.425.821.981 1.674 2.649 1.674 1.341 0 2.486-.591 2.486-1.674 0-1.346-1.407-1.708-3.369-2.167-1.7-.427-5.004-1.215-5.004-4.499 0-2.758 2.519-4.203 5.92-4.203 4.677 0 5.494 2.89 5.494 3.579 0 1.018-.589 1.675-1.472 1.675-.85 0-1.373-.591-1.504-.821-.752-1.084-.916-1.313-1.537-1.609-.425-.197-.883-.23-1.21-.23-1.21 0-2.159.46-2.159 1.248 0 .985 1.309 1.313 3.107 1.707.981.23 2.911.821 3.958 1.544.981.722 1.537 2.068 1.537 3.283-.033 2.693-2.028 4.926-6.214 4.926ZM221.766 112.594c0 1.248-.033 1.905-.458 2.364a1.774 1.774 0 0 1-1.275.526c-.458 0-.916-.197-1.276-.526-.458-.459-.458-1.116-.458-2.364v-5.418c0-1.248 0-1.871.458-2.331.295-.296.753-.558 1.276-.558.36 0 1.471.197 1.7 1.412.099.459.066.623.066 1.477v5.418h-.033ZM220 103.4a1.608 1.608 0 0 1-1.602-1.609c0-.886.719-1.609 1.602-1.609a1.61 1.61 0 0 1 0 3.218ZM240.44 112.594c0 1.248-.033 1.905-.458 2.364a1.753 1.753 0 0 1-1.242.526c-.458 0-.949-.197-1.309-.526-.458-.459-.458-1.116-.458-2.364v-3.481c0-.656 0-2.167-1.406-2.167-1.831 0-1.831 2.2-1.831 2.923v2.692c0 1.248 0 1.905-.458 2.364a1.776 1.776 0 0 1-1.276.526c-.457 0-.915-.197-1.275-.526-.458-.459-.458-1.116-.458-2.364v-3.218c0-1.247-.131-2.397-1.373-2.397-1.897 0-1.897 2.102-1.897 2.956v2.692c0 1.248 0 1.905-.458 2.364a1.755 1.755 0 0 1-1.243.526c-.458 0-.948-.197-1.308-.526-.458-.459-.458-1.116-.458-2.364v-5.648c0-1.149.033-1.707.458-2.167.294-.295.687-.525 1.177-.525 1.014 0 1.57.755 1.603 1.74.85-.985 1.799-1.74 3.532-1.74 2.158 0 2.878 1.248 3.139 1.74.982-1.084 1.897-1.74 3.5-1.74 1.275 0 2.714.459 3.303 2.101.229.657.262 1.938.262 2.069v4.17h-.066ZM245.64 116.666c0 1.247 0 1.904-.458 2.364-.261.263-.687.558-1.275.558-.458 0-.916-.197-1.276-.525-.458-.46-.458-1.15-.458-2.364v-9.687c0-1.182 0-1.74.426-2.167.294-.263.686-.526 1.21-.526.981 0 1.537.624 1.602 1.806.294-.426 1.308-1.806 3.369-1.806 2.387 0 4.48 1.938 4.48 5.615 0 3.415-1.962 5.615-4.546 5.615-1.7 0-2.583-.919-3.074-1.412v2.529Zm-.033-6.863c0 2.857 1.766 2.988 2.159 2.988.752 0 2.027-.46 2.027-2.988 0-2.397-1.21-2.922-2.027-2.922-.916 0-2.159.558-2.159 2.922ZM258.1 112.594c0 1.248 0 1.905-.458 2.364a1.772 1.772 0 0 1-1.275.526c-.458 0-.916-.197-1.275-.526-.458-.459-.458-1.116-.458-2.364v-9.522c0-1.248.032-1.872.458-2.364a1.772 1.772 0 0 1 1.275-.526c.458 0 .916.197 1.275.526.458.459.458 1.116.458 2.364v9.522ZM263.202 110.821c.033 1.97 1.603 2.364 2.257 2.364 1.144 0 1.995-.689 2.354-.952.426-.296.851-.657 1.407-.657.752 0 1.341.657 1.341 1.248 0 1.215-1.734 2.66-4.971 2.66-4.481 0-5.953-2.824-5.953-5.582 0-2.332 1.21-5.615 5.658-5.615 4.055 0 5.298 3.053 5.298 4.564 0 .427-.131 1.412-1.144 1.806-.426.164-1.243.197-1.701.197h-4.546v-.033Zm4.023-1.872c.032-1.379-.818-2.364-2.061-2.364-1.733 0-1.929 1.839-1.962 2.364h4.023Z",
  fill: "#009B3E"
})));
/* harmony default export */ var logo_full_webuyanycar = (SvgLogoFullwebuyanycar);
// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/wbac/wbac.module.css
var wbac_module = __webpack_require__(62977);
var wbac_module_default = /*#__PURE__*/__webpack_require__.n(wbac_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/wbac/wbac.tsx







/**
 * HOW HAS NO ONE USED TARGET=_BLANK BEFORE...
 * this works, and only expands the prop to add target.
 */ const CTALink = index_esm/* Primary */.sq;
const TrackingEvents = {
    cta_click: {
        eventName: `We buy any car link`,
        type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
        data: {
            event: {
                name: "click",
                category: "link",
                label: "We buy any car",
                action: "We buy any car link click"
            }
        }
    }
};
const CTAUrl = "https://www.webuyanycar.com/?utm_source=cinch%5Fwebsite&utm_medium=button%5Fid%5F123&utm_campaign=sell%5Fyour%5Fcar";
const WeBuyAnyCar = ({ body , cta  })=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const sendTrackEvent = ()=>trackEvent(TrackingEvents.cta_click);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Wrapper */.im, {
        "data-testid": "wbac",
        className: {
            inner: (wbac_module_default()).innerWrapper
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                className: (wbac_module_default()).heading,
                children: body
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CTALink, {
                element: "a",
                href: CTAUrl,
                onClick: sendTrackEvent,
                classNames: {
                    button: (wbac_module_default()).cta
                },
                target: "_blank",
                children: cta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (wbac_module_default()).logoWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_full_webuyanycar, {
                    className: (wbac_module_default()).logo
                })
            })
        ]
    });
};
/* harmony default export */ var wbac_wbac = (WeBuyAnyCar);

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/recent-and-recommended-vehicles/assets/search.svg
var _g, _defs;
function search_extends() { search_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return search_extends.apply(this, arguments); }

const SvgSearch = props => /*#__PURE__*/react.createElement("svg", search_extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.666 16.727A9.462 9.462 0 0 1 9.5 19 9.5 9.5 0 1 1 19 9.5a9.462 9.462 0 0 1-2.273 6.166l6.803 6.804a.75.75 0 1 1-1.06 1.06l-6.804-6.803ZM17.5 9.5a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
  fill: "#8DFFBE"
}))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/react.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
/* harmony default export */ var search = (SvgSearch);
// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/recent-and-recommended-vehicles/cards/cards.module.css
var cards_module = __webpack_require__(33192);
var cards_module_default = /*#__PURE__*/__webpack_require__.n(cards_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/recent-and-recommended-vehicles/cards/cards.tsx






const FindSimilarVehiclesCard = ()=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const sendTrackEvent = ()=>{
        trackEvent({
            eventName: `Browse all cars`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: "click",
                    category: "recently-viewed",
                    label: "browse-all-cars",
                    action: "car-search-cta"
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (cards_module_default()).vehicleCardContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: (cards_module_default()).findSimilarVehiclesCard,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (cards_module_default()).textContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(search, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                            className: (cards_module_default()).text,
                            fontWeight: "bold",
                            fontSize: "xl",
                            lineHeight: "display",
                            children: [
                                "Looking for something different?",
                                " "
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Secondary */.T7, {
                    element: "a",
                    variant: "alternative",
                    classNames: {
                        button: (cards_module_default()).button
                    },
                    href: "/used-cars",
                    onClick: ()=>sendTrackEvent(),
                    children: "Browse all cars"
                })
            ]
        })
    });
};
const VehicleCard = ({ vehicle , carouselName  })=>{
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const handleClick = ()=>{
        trackEvent({
            eventName: `${carouselName} - PDP Cards`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: carouselName,
                    label: vehicle.vehicleId,
                    action: "Open"
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (cards_module_default()).vehicleCardContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* VehicleCard */.Ur, {
            id: vehicle.vehicleId,
            isSaved: false,
            isPending: vehicle.isReserved,
            isAvailable: vehicle.isAvailable,
            vehicle: vehicle,
            isSmallCardSize: true,
            onCardClick: handleClick,
            isPersonalised: true
        }, vehicle.vehicleId)
    });
};
const VehicleCardsList = ({ vehicles , carouselName  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: (cards_module_default()).vehicleCardList,
        "aria-label": carouselName,
        children: [
            vehicles.map((vehicle)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleCard, {
                        vehicle: vehicle,
                        carouselName: carouselName
                    }, vehicle.vehicleId)
                }, vehicle.vehicleId)),
            vehicles.length <= 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: (cards_module_default()).vehicleCardListItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindSimilarVehiclesCard, {})
            }, "find-similar") : null
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/recent-and-recommended-vehicles/cards/index.tsx


// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/recent-and-recommended-vehicles/carousel/carousel.module.css
var carousel_module = __webpack_require__(17635);
var carousel_module_default = /*#__PURE__*/__webpack_require__.n(carousel_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/recent-and-recommended-vehicles/carousel/carousel.tsx




const Carousel = ({ carouselName , slidesPerView , vehicles  })=>{
    const navAriaLabels = {
        previous: "Go to previous slide",
        next: "Go to next slide"
    };
    const swiperSettings = {
        spaceBetween: 16,
        slidesPerView,
        cssMode: true,
        effect: "cards"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Carousel */.lr, {
                name: carouselName,
                swiperSettings: swiperSettings,
                ariaLabel: `${carouselName}-carousel`,
                children: [
                    vehicles.map((vehicle)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselSlide */.qs, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleCard, {
                                vehicle: vehicle,
                                carouselName: carouselName
                            })
                        }, vehicle.vehicleId);
                    }),
                    vehicles.length <= 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselSlide */.qs, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindSimilarVehiclesCard, {})
                    }, "cta-card") : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* CarouselControls */.J8, {
                customClassNames: (carousel_module_default()).controlsWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselPagination */.Jj, {
                        name: carouselName,
                        customClassNames: (carousel_module_default()).customPagination
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselNavigation */.Pn, {
                        name: carouselName,
                        ariaLabels: navAriaLabels,
                        customClassNames: {
                            prevButton: (carousel_module_default()).prevButton,
                            nextButton: (carousel_module_default()).nextButton
                        }
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/recent-and-recommended-vehicles/tabs/tabs.module.css
var tabs_module = __webpack_require__(52562);
var tabs_module_default = /*#__PURE__*/__webpack_require__.n(tabs_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/recent-and-recommended-vehicles/tabs/tabs.tsx





const TabsContext = /*#__PURE__*/ (0,react.createContext)({
    activeTab: 1,
    setActiveTab: ()=>null
});
const useTabs = ()=>(0,react.useContext)(TabsContext);
const Tabs = ({ children  })=>{
    const [activeTab, setActiveTab] = (0,react.useState)(1);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContext.Provider, {
        value: {
            activeTab,
            setActiveTab
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (tabs_module_default()).tabsWrapper,
            children: children
        })
    });
};
const TabButton = ({ tabOrderNumber , children  })=>{
    const { activeTab , setActiveTab  } = useTabs();
    const isActive = activeTab === tabOrderNumber;
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const handleClick = (tabOrderNumber)=>{
        trackEvent({
            eventName: `Personalised Component`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: "Personalised Component",
                    label: tabOrderNumber === 1 ? "Recently Viewed tab" : "You Might Like tab",
                    action: "Tab Clicked"
                }
            }
        });
        setActiveTab(tabOrderNumber);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        id: `tab-${tabOrderNumber}`,
        type: "button",
        role: "tab",
        className: classnames_default()((tabs_module_default()).tabButton, {
            [(tabs_module_default()).tabButtonLeft]: tabOrderNumber === 1,
            [(tabs_module_default()).tabButtonRight]: tabOrderNumber === 2
        }),
        "aria-selected": isActive,
        "aria-controls": `tabpanel-${tabOrderNumber}`,
        tabIndex: 0,
        onClick: ()=>handleClick(tabOrderNumber),
        children: children
    });
};
const TabPanel = ({ tabOrderNumber , children  })=>{
    const { activeTab  } = useTabs();
    const isActiveTab = activeTab === tabOrderNumber;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: `tabpanel-${tabOrderNumber}`,
        role: "tabpanel",
        tabIndex: isActiveTab ? 0 : -1,
        "aria-labelledby": `tab-${tabOrderNumber}`,
        className: classnames_default()((tabs_module_default()).tabPanel, {
            [(tabs_module_default()).tabPanelIsHidden]: !isActiveTab,
            [(tabs_module_default()).tabPanelLeft]: activeTab === 1,
            [(tabs_module_default()).tabPanelRight]: activeTab === 2
        }),
        children: isActiveTab ? children : null
    });
};
const TabButtonList = ({ children  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "tablist",
        "aria-labelledby": "tablist-1",
        className: (tabs_module_default()).tabButtonList,
        children: children
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/recent-and-recommended-vehicles/recent-and-recommended-vehicles.tsx







const RecentAndRecommendedVehicles = ({ recentlyViewedListings , similarListings  })=>{
    const { vw  } = (0,util_src/* useViewport */.Sj)({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    (0,react.useEffect)(()=>{
        /**
     * Work around as there is a race condition happening in the datalayer
     * which means that sometimes the track event fires before Adobe scripts
     * have loaded.
     */ setTimeout(()=>{
            trackEvent({
                eventName: "Welcome back module",
                type: analytics_src/* TrackingEventTypes.PAGE */.md.PAGE,
                data: {
                    event: {
                        category: "welcome-back-module",
                        label: "personalised-component",
                        action: "triggered",
                        name: "load"
                    }
                }
            });
        }, 3000);
    }, []);
    const isDesktop = vw >= 1024;
    const isTablet = vw >= 768 && vw < 1024;
    const isMobile = vw < 768;
    const hasVehicleListingsData = recentlyViewedListings && (recentlyViewedListings === null || recentlyViewedListings === void 0 ? void 0 : recentlyViewedListings.length) >= 1 && similarListings && (similarListings === null || similarListings === void 0 ? void 0 : similarListings.length) >= 1;
    if (hasVehicleListingsData) {
        const showRecentlyViewedCarousel = isMobile || isTablet && (recentlyViewedListings === null || recentlyViewedListings === void 0 ? void 0 : recentlyViewedListings.length) >= 2 || isDesktop && (recentlyViewedListings === null || recentlyViewedListings === void 0 ? void 0 : recentlyViewedListings.length) >= 4;
        const slidesPerView = isMobile ? 1 : isTablet ? 2 : 3;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabButtonList, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabButton, {
                            tabOrderNumber: 1,
                            children: "Recently viewed"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabButton, {
                            tabOrderNumber: 2,
                            children: "You might like"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel, {
                    tabOrderNumber: 1,
                    children: showRecentlyViewedCarousel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
                        slidesPerView: slidesPerView,
                        carouselName: "recently-viewed-cars",
                        vehicles: recentlyViewedListings
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleCardsList, {
                        vehicles: recentlyViewedListings,
                        carouselName: "recently-viewed-cars"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabPanel, {
                    tabOrderNumber: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
                        slidesPerView: slidesPerView,
                        carouselName: "you-might-like",
                        vehicles: similarListings
                    })
                })
            ]
        });
    } else {
        return null;
    }
};

// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/help-me-choose/help-me-choose.module.css
var help_me_choose_module = __webpack_require__(87544);
var help_me_choose_module_default = /*#__PURE__*/__webpack_require__.n(help_me_choose_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/help-me-choose/help-me-choose.tsx






const HelpMeChoose = ({ title , heading , body , ctaText , image  })=>{
    const { vw  } = (0,util_src/* useViewport */.Sj)({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isMobile = vw < 1024;
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const handleClick = ()=>{
        trackEvent({
            eventName: `Help me choose`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: analytics_src/* EventNames.click */.Vy.click,
                    category: "button",
                    label: "Help me choose quiz banner",
                    action: "Help me choose"
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                element: "h2",
                className: (help_me_choose_module_default()).title,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (help_me_choose_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (help_me_choose_module_default()).leftSection,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    element: "h3",
                                    className: (help_me_choose_module_default()).heading,
                                    children: heading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    element: "p",
                                    className: (help_me_choose_module_default()).body,
                                    children: body
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Secondary */.T7, {
                                    "data-testid": "help-me-choose-button",
                                    classNames: {
                                        button: (help_me_choose_module_default()).buttonContainer
                                    },
                                    type: "submit",
                                    variant: "alternative",
                                    element: "a",
                                    href: "/help-me-choose/most-important",
                                    onClick: handleClick,
                                    children: ctaText
                                })
                            ]
                        })
                    }),
                    isMobile ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (help_me_choose_module_default()).image,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: image.filename,
                            alt: image.alt ?? "",
                            layout: "responsive",
                            width: 408,
                            height: 265
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var help_me_choose = (HelpMeChoose);

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/value-propositions/assets/shield.svg
var shield_path;
function shield_extends() { shield_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return shield_extends.apply(this, arguments); }

const SvgShield = props => /*#__PURE__*/react.createElement("svg", shield_extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), shield_path || (shield_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.692.278a.997.997 0 0 0-1.384 0c-1.046 1.003-2.967 2.51-5.261 3.695-2.307 1.193-4.88 2.005-7.27 1.776a1 1 0 0 0-1.096.996v8.27c-.231 4.24 2.366 13.211 14.005 16.934a.997.997 0 0 0 .629 0C27.954 28.226 30.55 19.254 30.32 15.015v-8.27a1 1 0 0 0-1.096-.996c-2.39.23-4.963-.583-7.27-1.776-2.294-1.186-4.215-2.692-5.262-3.695ZM28.322 15.1c.196 3.398-1.884 11.374-12.322 14.848C5.563 26.474 3.482 18.498 3.68 15.1V7.788c2.574-.018 5.126-.921 7.285-2.038A26.71 26.71 0 0 0 16 2.35a26.713 26.713 0 0 0 5.035 3.4c2.16 1.117 4.712 2.02 7.285 2.038v7.255l.001.057Zm-3.442-3.586a.75.75 0 1 0-1.093-1.027l-9.821 10.455-4.454-4.157a.75.75 0 0 0-1.023 1.097l5 4.666a.75.75 0 0 0 1.058-.034l10.333-11Z",
  fill: "#5234B6"
})));
/* harmony default export */ var shield = (SvgShield);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/value-propositions/assets/union-shield.svg
var union_shield_path, union_shield_path2;
function union_shield_extends() { union_shield_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return union_shield_extends.apply(this, arguments); }

const SvgUnionShield = props => /*#__PURE__*/react.createElement("svg", union_shield_extends({
  width: 30,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), union_shield_path || (union_shield_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.076 9.669c2.255-.975 4.277.342 5.924 1.82 1.648-1.477 3.67-2.795 5.925-1.82 1.661.718 2.712 2.451 2.742 4.243 0 2.978-4.741 7.923-7.66 10.967l-.008.008-.47.49a.73.73 0 0 1-1.057 0l-.475-.496-.002-.001c-2.92-3.044-7.661-7.99-7.661-10.968.03-1.792 1.08-3.525 2.742-4.243Zm11.056 1.835c.864.374 1.509 1.344 1.535 2.422-.005.27-.13.789-.556 1.595-.413.785-1.02 1.674-1.757 2.62-1.334 1.711-2.965 3.446-4.353 4.897-1.388-1.45-3.02-3.185-4.354-4.896-.738-.947-1.344-1.835-1.757-2.62-.426-.807-.552-1.327-.556-1.596.026-1.078.67-2.048 1.535-2.421 1.025-.443 2.143-.01 3.796 1.473a2 2 0 0 0 2.67 0c1.654-1.482 2.772-1.916 3.797-1.473Z",
  fill: "#5234B6"
})), union_shield_path2 || (union_shield_path2 = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.692.278a.997.997 0 0 0-1.384 0c-1.046 1.003-2.967 2.51-5.261 3.695-2.307 1.193-4.88 2.005-7.27 1.776a1 1 0 0 0-1.096.996v8.27c-.231 4.24 2.366 13.211 14.005 16.934a.997.997 0 0 0 .629 0C26.954 28.226 29.55 19.254 29.32 15.015v-8.27a1 1 0 0 0-1.096-.996c-2.39.23-4.963-.583-7.27-1.776-2.294-1.186-4.215-2.692-5.262-3.695ZM27.322 15.1c.196 3.398-1.884 11.374-12.322 14.848C4.563 26.474 2.482 18.498 2.68 15.1V7.788c2.574-.018 5.126-.921 7.285-2.038A26.709 26.709 0 0 0 15 2.35a26.713 26.713 0 0 0 5.035 3.4c2.16 1.117 4.712 2.02 7.285 2.038v7.255l.001.057Z",
  fill: "#5234B6"
})));
/* harmony default export */ var union_shield = (SvgUnionShield);
// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/value-propositions/value-propositions.module.css
var value_propositions_module = __webpack_require__(96450);
var value_propositions_module_default = /*#__PURE__*/__webpack_require__.n(value_propositions_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/value-propositions/value-propositions.tsx







const ValuePropositions = ({ heading , body , icon  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (value_propositions_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (value_propositions_module_default()).imageContainer,
                children: icon === "shield" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* SVG */.Wj, {
                    className: (value_propositions_module_default()).icon,
                    children: shield
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* SVG */.Wj, {
                    className: (value_propositions_module_default()).icon,
                    children: union_shield
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        className: (value_propositions_module_default()).heading,
                        children: heading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (value_propositions_module_default()).body,
                        children: (0,shared_src/* renderWithResolver */.be)(body)
                    })
                ]
            })
        ]
    });
/* harmony default export */ var value_propositions = (ValuePropositions);

// EXTERNAL MODULE: ../../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(82070);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/icon/icon.tsx


function StoryblokIcon({ iconName , color ="monochrome-white" , size =24  }) {
    const Icon = dynamic_default()({
        loader: async ()=>{
            const icons = await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 58544));
            function isIconName(input) {
                return input in icons;
            }
            if (!isIconName(iconName)) {
                return icons.BinIcon;
            }
            const Icon = icons[iconName];
            return Icon;
        },
        ssr: true
    }, {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(58544)
                ]
        },
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(58544)
                ]
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
        color: color,
        size: size
    });
}

// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/usp/usp-slide.module.css
var usp_slide_module = __webpack_require__(30808);
var usp_slide_module_default = /*#__PURE__*/__webpack_require__.n(usp_slide_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/usp/usp-slide.tsx








const { Context: usp_slide_Context , Actions: usp_slide_Actions  } = shared_src/* Datadog */.og;
function UspSlide(blok) {
    const { trackEvent  } = (0,analytics_src/* useAnalytics */.z$)();
    const { title , text , icon , link  } = blok;
    const handleTrackEvent = ()=>{
        entries_main/* datadogRum.addAction */.v.addAction(usp_slide_Actions.CLICK_USP_LINK, {
            service: usp_slide_Context.HERO_USP,
            squad: usp_slide_Context.SQUAD,
            page: "/",
            category: "hero",
            label: "usp-click - below main hero",
            value: `${title} usp-click`
        });
        trackEvent({
            eventName: `${title} usp-click`,
            type: analytics_src/* TrackingEventTypes.ADOBE */.md.ADOBE,
            data: {
                event: {
                    name: "click",
                    category: "hero",
                    label: "below main hero",
                    action: `${title}`
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        href: link.url,
        className: (usp_slide_module_default()).slideCard,
        ...(0,src/* storyblokEditable */.LF)(blok),
        onClick: ()=>handleTrackEvent(),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoryblokIcon, {
                iconName: icon,
                color: "primary-purple",
                size: 24
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: text
            })
        ]
    });
}

// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/components/usp/usp-container.module.css
var usp_container_module = __webpack_require__(1044);
var usp_container_module_default = /*#__PURE__*/__webpack_require__.n(usp_container_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/usp/usp-container.tsx






function USPContainer({ slides =[]  }) {
    const { vw  } = (0,util_src/* useViewport */.Sj)({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isTablet = vw >= 768 && vw < 1024;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Wrapper */.im, {
        className: {
            container: (usp_container_module_default()).carouselWrapper,
            inner: (usp_container_module_default()).carouselInner
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (usp_container_module_default()).uspContainerDesktop,
                "data-testid": "USPContainerDesktop",
                children: slides.map((slide)=>/*#__PURE__*/ (0,react.createElement)(UspSlide, {
                        ...slide,
                        key: slide._uid
                    }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (usp_container_module_default()).uspContainerMobile,
                "data-testid": "USPContainerMobile",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Carousel */.lr, {
                        name: "usp",
                        swiperSettings: {
                            slidesPerView: isTablet ? 2.1 : 1.1
                        },
                        children: slides.map((slide)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* CarouselSlide */.qs, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UspSlide, {
                                    ...slide
                                })
                            }, slide._uid))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* CarouselControls */.J8, {
                        customClassNames: (usp_container_module_default()).carouselControls,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* CarouselNavigation */.Pn, {
                                name: "usp",
                                ariaLabels: {
                                    next: "Next USP",
                                    previous: "Previous USP"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* CarouselPagination */.Jj, {
                                name: "usp"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/components/index.ts














;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/data/storyblok-renderer-map.ts

const storyblokComponents = {
    HomeHeroV2: hero,
    HelpMeChooseSection: help_me_choose,
    WhyCinchSection: why_cinch,
    PartExSection: part_ex,
    ValuePropsCard: value_propositions,
    HomeUspSlide: UspSlide
};

// EXTERNAL MODULE: ../../../libs/landing/feature-homepage/src/lib/homepage.module.css
var homepage_module = __webpack_require__(46567);
var homepage_module_default = /*#__PURE__*/__webpack_require__.n(homepage_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/locale/index.ts
const homePage = {
    seo: {
        title: "Buy Used Cars Without The Faff - cinch",
        description: "The faff-free way to buy a car online. Thousands of cars in one place, with home delivery and a 14-day money back guarantee."
    },
    hero: {
        helpMeChoose: {
            mobile: {
                paragraph1: "Not sure where to start?",
                paragraph2: "Try our ",
                link: "Help Me Choose tool"
            },
            desktop: {
                paragraph1: "Not sure where to start? Try our ",
                link: "Help Me Choose tool"
            }
        }
    },
    articles: {
        title: "Articles",
        cta: "All articles"
    },
    reviews: {
        title: "Reviews",
        cta: "All reviews"
    },
    cinchCare: {
        title: "Worry-free motoring",
        bullets: [
            "Comprehensive lifetime warranty",
            "Servicing by a nationwide provider",
            "The reassurance of RAC breakdown assistance",
            "For less than \xa335 a month"
        ],
        button: "Tell me more"
    },
    ourCommitmentSlides: {
        slides: [
            {
                iconName: "check-circle",
                title: "cinch quality assured",
                body: "All cars are thoroughly checked by highly trained technicians and come with a minimum 6 month MOT."
            },
            {
                iconName: "cash",
                title: "Money-back guarantee",
                body: 'Enjoy your cinch car for <a href="/returns">14 days</a> to make sure it’s right for you. Changed your mind? We’ll collect it and give you a full refund. Totally faff-free.'
            },
            {
                iconName: "shield-heart",
                title: "Caring for your car",
                body: 'All our cars come with a 90-day warranty, including breakdown assistance. Add <a href="/car-care/cinch-cover">cinchCover</a> at checkout to protect yourself against the cost of mechanical, electrical and cosmetic repairs.'
            }
        ]
    },
    trustpilotReviews: {
        title: "The nation is cinching it",
        reviews: []
    },
    sponsorSection: {
        logoAlt: "England cricket logo",
        imageAlt: "England cricket players"
    },
    wbac: {
        body: "Just looking to sell for now? Try our sister site webuyanycar.",
        cta: "Get a free car valuation"
    }
};
/* harmony default export */ var locale = (homePage);

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/homepage.tsx










const LandingFeatureHomePage = ({ preview , vehiclesData , trustpilotData , story , showPersonalisedComponents , recentlyViewedListings , similarListings  })=>{
    story = (0,src/* useStoryblokState */.f0)({
        story,
        enableBridge: preview
    });
    const { ourCommitmentSlides , wbac , trustpilotReviews , seo  } = locale;
    saveCustomerJourneyCookie();
    const isProd = "production" === "production";
    // TODO: uncomment when continue with favouriting on home when A&E is back
    // const showFavouritingTab =
    //   readFromEnv(Env.EnableFavouritingHomePageChanges) === 'true'
    // const { status: userStatus } = useUserStore()
    // const { favourites } = useFavouritesStore()
    // this console.logs are required in the ticket to prove we are getting favourites and user Status.
    // console.log('userStatus', userStatus)
    // console.log('favourites', favourites)
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Head */.Fb, {
                ...story,
                fallbackTitle: seo.title,
                fallbackDescription: seo.description
            }),
            !!story.content.herov2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                block: story.content.herov2,
                components: storyblokComponents,
                props: {
                    makes: vehiclesData.makes,
                    totalStock: vehiclesData.totalStock,
                    starRating: trustpilotData.stars,
                    starRatingLabel: trustpilotData.starRatingLabel,
                    numberOfReviews: trustpilotData.total
                }
            }),
            story.content.usp ? /*#__PURE__*/ (0,jsx_runtime.jsx)(USPContainer, {
                slides: story.content.usp
            }) : null,
            showPersonalisedComponents ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Wrapper */.im, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        element: "h2",
                        className: (homepage_module_default()).heading,
                        children: "Welcome back"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentAndRecommendedVehicles, {
                        recentlyViewedListings: recentlyViewedListings ?? [],
                        similarListings: similarListings ?? []
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (homepage_module_default()).valuePropsCardsContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                            block: story.content.personalised[0].valuePropositions,
                            components: storyblokComponents
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                        block: story.content.personalised[0].helpMeChoose,
                        components: storyblokComponents
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shop_by_shape_component, {
                count: vehiclesData.carTypes
            }),
            !showPersonalisedComponents ? /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                block: story.content.whyCinch,
                components: storyblokComponents
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                block: story.content.partEx,
                components: storyblokComponents
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* TrustpilotReviews */.u8, {
                title: trustpilotReviews.title,
                starRatingLabel: trustpilotData.starRatingLabel,
                numberOfReviews: trustpilotData.total,
                reviews: trustpilotData.reviews
            }),
            !showPersonalisedComponents ? /*#__PURE__*/ (0,jsx_runtime.jsx)(our_commitment_carousel, {
                ...ourCommitmentSlides
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(wbac_wbac, {
                ...wbac
            }),
            isProd ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: "ZeroFox",
                className: (homepage_module_default()).zeroFox,
                src: "https://d21y75miwcfqoq.cloudfront.net/786a6533"
            }) : null
        ]
    });
};
/* harmony default export */ var homepage = (LandingFeatureHomePage);

// EXTERNAL MODULE: ../../../libs/data/search/src/lib/constants/index.ts + 2 modules
var constants = __webpack_require__(9722);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/data/api.ts

const getSearchAPIData = async ()=>{
    const response = await fetch(constants/* VEHICLE_SEARCH_URL */.Eb).then((res)=>res.json());
    return response;
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/data/vehicles.ts

const getHomePageVehiclesData = async ()=>{
    const res = await getSearchAPIData();
    const makesData = res.facets.makes;
    const makes = makesData.map((make)=>({
            name: make.name,
            stock: make.doc_count,
            models: make.models.map((model)=>({
                    name: model.name,
                    stock: model.doc_count
                }))
        }));
    const carTypes = {
        ...res.facets.bodyType,
        electric: res.facets.fuelType.electric
    };
    const monthlyPriceBucket = {
        ...res.facets.monthlyPriceBucket
    };
    const priceBucket = {
        ...res.facets.priceBucket
    };
    const vehiclesData = {
        totalStock: res.searchResultsCount,
        makes,
        carTypes,
        monthlyPriceBucket,
        priceBucket
    };
    return vehiclesData;
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/data/content.ts

const isDev = "production" !== "production";
const getHomePageContentData = async (preview = false)=>{
    const story = await (0,src/* getStoryBySlug */.OI)("home", {
        version: preview ? "draft" : "published",
        ...isDev && {
            cv: Date.now()
        }
    });
    return story ?? undefined;
};

// EXTERNAL MODULE: ../../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(12093);
// EXTERNAL MODULE: ../../../libs/core/datadog-server/src/index.ts + 7 modules
var datadog_server_src = __webpack_require__(86634);
;// CONCATENATED MODULE: ../../../libs/data/trustpilot/src/api/get-reviews.ts



const Review = lib.z.object({
    starRating: lib.z.number(),
    title: lib.z.string(),
    description: lib.z.string(),
    customerName: lib.z.string(),
    date: lib.z.string().datetime(),
    link: lib.z.string().url()
});
const TrustpilotReviewsResponse = lib.z.object({
    trustScore: lib.z.number(),
    stars: lib.z.number(),
    total: lib.z.number(),
    starRatingLabel: lib.z.string(),
    reviews: lib.z.array(Review).min(3).max(3)
});
const fallbackResponse = {
    trustScore: 4.3,
    total: 35663,
    stars: 4.5,
    starRatingLabel: "Excellent",
    reviews: [
        {
            starRating: 5,
            title: "Everything is so easy and…",
            description: `Everything is so easy and straightforward to do and buying a car has never been so easy and stress free because of cinch’s 14 day returns and six month warranty and our delivery guy lucian stoica (lucs thank you)was a really nice bloke and went through the car with us and answered any questions we had.Couldn’t have gone any better definitely the new way to buy a car.Well done cinch.`,
            customerName: "Mark Perry",
            date: "01 May 2024",
            link: "https://uk.trustpilot.com/review/cinch.co.uk"
        },
        {
            starRating: 5,
            title: "So pleased with the service people…",
            description: `So pleased with the service people should cinch it great experience throughout ,professional.
        The only downside for me was the £99 admin fee especially because I sent my first car back within 14 days because I changed my mind, it should be wavered 2nd time.
        I am so pleases with my new car now, thank you so much`,
            customerName: "Lisa Shelley",
            date: "01 May 2024",
            link: "https://uk.trustpilot.com/review/cinch.co.uk"
        },
        {
            starRating: 5,
            title: "This has been an amazing experience",
            description: `This has been an amazing experience! So straightforward, well looked after every step of the way, including a welcome video from the finance company via cinch. Viru delivered the car and was simply charming 😊 I would definitely recommend buying through cinch, thanks everyone! 👏👍👏`,
            customerName: "K from London",
            date: "01 May 2024",
            link: "https://uk.trustpilot.com/review/cinch.co.uk"
        }
    ]
};
async function getTrustpilotReviewsFn() {
    try {
        const url = `${(0,environments_src/* readFromEnv */.u)("TRUSTPILOT_URL")}/trustpilot-get-reviews`;
        const response = await fetch(url);
        (0,datadog_server_src/* setTag */.YA)("request.url", url);
        (0,datadog_server_src/* setTag */.YA)("request.method", "GET");
        (0,datadog_server_src/* setTag */.YA)("request.status", response.status);
        (0,datadog_server_src/* setTag */.YA)("request.content-length", response.headers.get("content-length") ?? "0");
        return TrustpilotReviewsResponse.parse(await response.json());
    } catch (error) {
        if (typeof error === "string" || error instanceof Error) {
            (0,datadog_server_src/* tagError */.$k)(error);
        }
        console.error(error);
        return fallbackResponse;
    }
}
const get_reviews_getTrustpilotReviews = (0,datadog_server_src/* traceFunction */.KG)("trustpilot.getTrustpilotReviews", getTrustpilotReviewsFn);

;// CONCATENATED MODULE: ../../../libs/data/trustpilot/src/hooks/use-trustpilot-reviews.ts



function useTrustpilotReviews() {
    const [trustpilotData, setTrustpilotData] = useState();
    useEffect(()=>{
        getTrustpilotReviews().then((data)=>{
            const formattedData = {
                ...data,
                reviews: data.reviews.map((review)=>({
                        ...review,
                        description: truncateContent(review.description),
                        date: formatDate(review.date)
                    }))
            };
            setTrustpilotData(formattedData);
        });
    }, []);
    return trustpilotData;
}
/* harmony default export */ var use_trustpilot_reviews = ((/* unused pure expression or super */ null && (useTrustpilotReviews)));
/***
 * Truncates the provided str to the desiredLength.
 * @param {string} inputString - the string we want to truncate.
 * @param {number} desiredLength - the Desired Maximum length. defaults to 135.
 *
 */ function truncateContent(inputString, desiredLength = 135) {
    return inputString.length > desiredLength ? [
        ...inputString.slice(0, desiredLength),
        "..."
    ].join("") : inputString;
}
/**
 * Formats the provided date.
 * @param {string} date | the Date string to be formatted.
 * @returns the formatted string.
 */ function formatDate(date) {
    try {
        return format(parseISO(date), "d MMMM yyyy");
    } catch  {
        // RangeError: Invalid time value
        // Return existing value
        return date;
    }
}

;// CONCATENATED MODULE: ../../../libs/data/trustpilot/src/hooks/use-trustpilot-score-context.ts

const defaultValues = {
    starRatingLabel: "Excellent",
    totalReviews: 10000,
    starRating: 4.5
};
const TrustpilotScoreContext = (0,react.createContext)(defaultValues);
function useTrustpilotScoreContext() {
    const context = useContext(TrustpilotScoreContext);
    if (context === undefined) {
        throw new Error("useTrustpilotScore must be used within a provider");
    }
    return context;
}

;// CONCATENATED MODULE: ../../../libs/data/trustpilot/src/index.ts




;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/data/get-recent-and-recommend-vehicles.ts

const MAX_VEHICLE_LISTINGS = 6;
const SEARCH_URL = (0,environments_src/* readFromEnv */.u)(environments_src/* Env.SearchServiceUrl */.X.SearchServiceUrl);
const getRecentAndRecommendVehicles = async (vehicleIds)=>{
    var ref;
    let recentVehicleResults;
    let similarVehicleResults;
    try {
        const data = await fetch(`${SEARCH_URL}/vehicles?vehicleIds=${vehicleIds.join(",")}&pageSize=${MAX_VEHICLE_LISTINGS}`);
        recentVehicleResults = await data.json();
    } catch  {
        throw new Error("Something went wrong with the fetching of vehicle listings");
    }
    try {
        const similarVehicleData = await fetch(`${SEARCH_URL}/similar?vehicleId=${vehicleIds[0]}&pageSize=${MAX_VEHICLE_LISTINGS}`);
        similarVehicleResults = await similarVehicleData.json();
    } catch  {
        throw new Error("Something went wrong with the fetching of similiar vehicles");
    }
    const vehicleListings = (recentVehicleResults === null || recentVehicleResults === void 0 ? void 0 : (ref = recentVehicleResults.vehicleListings) === null || ref === void 0 ? void 0 : ref.filter((vehicle)=>!vehicle.isReserved)) || [];
    const similarVehicleListing = (similarVehicleResults === null || similarVehicleResults === void 0 ? void 0 : similarVehicleResults.vehicleListings) || [];
    const orderedVehicles = vehicleIds.reduce((vehicles, vehicleId)=>{
        const vehicleToOrder = vehicleListings.find((recentVehicle)=>recentVehicle.vehicleId === vehicleId);
        if (vehicleToOrder) {
            vehicles = [
                ...vehicles,
                vehicleToOrder
            ];
        }
        return vehicles;
    }, []);
    return {
        recentlyViewedListings: orderedVehicles,
        similarListings: similarVehicleListing
    };
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/helpers/get-personalisation-eligibility.ts


const getPersonalisationEligibility = async (cookies)=>{
    try {
        const vehicleIds = cookies["cinch-recently-viewed-cars"];
        const cookiePreferences = cookies["cp"] ? JSON.parse(cookies["cp"]) : null;
        const hasFunctionalCookies = cookies && (cookiePreferences === null || cookiePreferences === void 0 ? void 0 : cookiePreferences.functional);
        const parsedVehicleIds = vehicleIds ? JSON.parse(vehicleIds) : [];
        const vehicleIdsAsAnArray = parsedVehicleIds.length > 0 ? parsedVehicleIds : [];
        let recentlyViewedListings = [];
        let similarListings = [];
        if (vehicleIdsAsAnArray.length > 0) {
            const data = await getRecentAndRecommendVehicles(vehicleIdsAsAnArray);
            recentlyViewedListings = data.recentlyViewedListings;
            similarListings = data.similarListings;
        }
        const hasPreviouslyViewedCars = vehicleIdsAsAnArray !== undefined && recentlyViewedListings.length > 0 && similarListings.length > 0;
        const showPersonalisedComponents = (hasPreviouslyViewedCars && hasFunctionalCookies) ?? false;
        return {
            showPersonalisedComponents,
            recentlyViewedListings,
            similarListings
        };
    } catch (error) {
        if (typeof error === "string" || error instanceof Error) {
            (0,datadog_server_src/* tagError */.$k)(error);
        }
        console.log("there is an error with the getRecentAndRecommendVehicles call", error);
        return {
            showPersonalisedComponents: false,
            recentlyViewedListings: [],
            similarListings: []
        };
    }
};

// EXTERNAL MODULE: ../../../libs/shared/experiments/adobe/src/index.ts + 14 modules
var adobe_src = __webpack_require__(82040);
;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/lib/get-server-side-props.ts






async function getServerSidePropsfn(ctx) {
    const isInsideStoryblok = !!ctx.preview;
    const [vehiclesData, story, trustpilotData, { showPersonalisedComponents , similarListings , recentlyViewedListings  }] = await Promise.all([
        getHomePageVehiclesData(),
        getHomePageContentData(isInsideStoryblok),
        get_reviews_getTrustpilotReviews(),
        getPersonalisationEligibility(ctx.req.cookies)
    ]);
    if (!story) {
        throw new Error("Unable to fetch `home` story from storyblok");
    }
    (0,datadog_server_src/* setTag */.YA)("response.code", 200);
    (0,datadog_server_src/* setTag */.YA)("page.name", "homepage");
    (0,datadog_server_src/* setTag */.YA)("page.url", ctx.resolvedUrl);
    (0,datadog_server_src/* setTag */.YA)("page.rendered", "SSR");
    (0,datadog_server_src/* setTag */.YA)("page.params", JSON.stringify({
        preview: isInsideStoryblok,
        query: ctx.query,
        showPersonalisedComponents
    }, null, 2));
    const homepageProdTest = await (0,adobe_src/* getAdobeTargetSSR */.o)(ctx, "HOMEPAGE_SSR_TEST", "SSR_PROD_TEST");
    (0,datadog_server_src/* setTag */.YA)("page.ssrAdobeTest", JSON.stringify(homepageProdTest, null, 2));
    return {
        props: {
            story,
            vehiclesData,
            showPersonalisedComponents,
            trustpilotData,
            preview: isInsideStoryblok,
            recentlyViewedListings,
            similarListings,
            generatedAt: Date.now().toString(),
            layoutProps: {
                hasPromoBanner: false
            }
        }
    };
}
const getServerSideProps = (0,datadog_server_src/* traceFunction */.KG)("homepage.getServerSideProps", getServerSidePropsfn);

;// CONCATENATED MODULE: ../../../libs/landing/feature-homepage/src/index.ts






;// CONCATENATED MODULE: ./pages/index.tsx
var pages_dirname = "/";
/** work-around for making standalone builds work in older versions of Nx **/ /** TODO: Remove this when we upgrade to Nx 16.3.0+ **/ 
path_default().resolve(pages_dirname, "../next.config.js");
var __N_SSP = true;



/***/ }),

/***/ 87544:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"help-me-choose_container__MdcNg","leftSection":"help-me-choose_leftSection__Nxua0","title":"help-me-choose_title__TI789","heading":"help-me-choose_heading__FAmhV","body":"help-me-choose_body__YCgHr","image":"help-me-choose_image__XR51c","buttonContainer":"help-me-choose_buttonContainer__nSS2M"};

/***/ }),

/***/ 25338:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"filters_container__k1Y7d","heading":"filters_heading__ecOy7","errorBox":"filters_errorBox__8_L5V","toPriceSelect":"filters_toPriceSelect__i7qzw","radioGroup":"filters_radioGroup__iOY1p","priceLabel":"filters_priceLabel__EYpIR","radioInputContainer":"filters_radioInputContainer__SbJpg","buttonContainer":"filters_buttonContainer__0JJ7X","trustpilotOverview":"filters_trustpilotOverview__VTyP8","helpMeChoose":"filters_helpMeChoose__4HEmW","link":"filters_link__Y_D8n"};

/***/ }),

/***/ 80387:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"toPriceSelect":"price_toPriceSelect__SFxGE","errorBox":"price_errorBox__FPicJ"};

/***/ }),

/***/ 3897:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading":"hero-heading_heading__oJ8ZQ"};

/***/ }),

/***/ 61012:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"hero-image_imageContainer__bg__b","isShownOnMobile":"hero-image_isShownOnMobile__pzD2b"};

/***/ }),

/***/ 1131:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"promoLink":"hero-link_promoLink__mGsq_"};

/***/ }),

/***/ 48291:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subheading":"hero-subheading_subheading__U0Lqf"};

/***/ }),

/***/ 80044:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"hero_container__f_q9W","background":"hero_background__zZ5sk","backgroundGradient":"hero_backgroundGradient__LOPDa","heroInner":"hero_heroInner__1d2fE","textAndImageContainer":"hero_textAndImageContainer__Urvtr","textContainer":"hero_textContainer__A6dxe","imageGridContainer":"hero_imageGridContainer__6Tc_T","isMobileImageShown":"hero_isMobileImageShown__G0ZBN","trustpilotWrapper":"hero_trustpilotWrapper__ZKCtc","trustpilotMobile":"hero_trustpilotMobile__vxt6N"};

/***/ }),

/***/ 48918:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customPagination":"our-commitment-carousel_customPagination__mDqI_","controlsWrapper":"our-commitment-carousel_controlsWrapper__fD8Yt","prevButton":"our-commitment-carousel_prevButton__8NS9w","nextButton":"our-commitment-carousel_nextButton__MfPn6"};

/***/ }),

/***/ 57613:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ourCommitmentSlideContainer":"our-commitment-slide_ourCommitmentSlideContainer__sQ_Du","ourCommitmentSlide":"our-commitment-slide_ourCommitmentSlide__1hbp3","title":"our-commitment-slide_title__m1aYw","body":"our-commitment-slide_body__cbpBR"};

/***/ }),

/***/ 38770:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"part-ex_container__b49Va","partExchangeMarketingSectionContainer":"part-ex_partExchangeMarketingSectionContainer__wwx8E","partExchangeMarketingSectionWrapper":"part-ex_partExchangeMarketingSectionWrapper__Y9nuB","partExchangeMarketingSectionLeftSection":"part-ex_partExchangeMarketingSectionLeftSection__vSoOq","partExchangeMarketingSectionTitle":"part-ex_partExchangeMarketingSectionTitle__SB5rr","partExchangeMarketingSectionSubTitle":"part-ex_partExchangeMarketingSectionSubTitle__3p124","partExchangeMarketingSectionSubTitleSpan":"part-ex_partExchangeMarketingSectionSubTitleSpan__e9dOa","vrmInputWrapper":"part-ex_vrmInputWrapper__N1_PS","vrmInputLabel":"part-ex_vrmInputLabel___RY_5","vrmInput":"part-ex_vrmInput__XE31b","partExchangeMarketingSectionImage":"part-ex_partExchangeMarketingSectionImage__zmM9Y","findMoreButton":"part-ex_findMoreButton__M2pEc","infoWrapper":"part-ex_infoWrapper__WlHuw","findMore":"part-ex_findMore__Hnc36"};

/***/ }),

/***/ 33192:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"vehicleCardList":"cards_vehicleCardList__qr_Ct","vehicleCardListItem":"cards_vehicleCardListItem__7_Tkx","vehicleCardContainer":"cards_vehicleCardContainer__I_4aC","findSimilarVehiclesCard":"cards_findSimilarVehiclesCard__2Syf9","textContainer":"cards_textContainer__g2oGY","text":"cards_text__L77px","button":"cards_button__TPF_n"};

/***/ }),

/***/ 17635:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"controlsWrapper":"carousel_controlsWrapper__GwI_5","customPagination":"carousel_customPagination__lne1g"};

/***/ }),

/***/ 52562:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tabButtonList":"tabs_tabButtonList__MOL_8","tabButton":"tabs_tabButton__qJe_k","tabButtonRight":"tabs_tabButtonRight__mraI_","tabButtonLeft":"tabs_tabButtonLeft__M9DSS","tabPanel":"tabs_tabPanel__sw0oy","tabPanelIsHidden":"tabs_tabPanelIsHidden___MBGo"};

/***/ }),

/***/ 49997:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"shop-by-shape-card_card__PyUjR","heading":"shop-by-shape-card_heading__SSOJ7","title":"shop-by-shape-card_title__oZnde","body":"shop-by-shape-card_body__H9nz6","link":"shop-by-shape-card_link__ZUoi1","button":"shop-by-shape-card_button__0cKJ2"};

/***/ }),

/***/ 67997:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading":"shop-by-shape-component_heading__jaW8o","container":"shop-by-shape-component_container__pnGYM","cards":"shop-by-shape-component_cards__vqZ_e"};

/***/ }),

/***/ 1044:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uspContainerDesktop":"usp-container_uspContainerDesktop__zBUvf","uspContainerMobile":"usp-container_uspContainerMobile__toV8c","carouselControls":"usp-container_carouselControls__CfPfz","carouselWrapper":"usp-container_carouselWrapper__YFNKm","carouselInner":"usp-container_carouselInner__sC2_6"};

/***/ }),

/***/ 30808:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slideCard":"usp-slide_slideCard__Wg_Vg"};

/***/ }),

/***/ 96450:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"value-propositions_imageContainer____vN_","root":"value-propositions_root__PUa4T","heading":"value-propositions_heading__gqK3T","body":"value-propositions_body__P6iU_","icon":"value-propositions_icon__XFVuO"};

/***/ }),

/***/ 62977:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"wbac_innerWrapper__AeWRv","logoWrapper":"wbac_logoWrapper__apBOK","logo":"wbac_logo__rsw9J","heading":"wbac_heading___xLn_","cta":"wbac_cta__K62qP"};

/***/ }),

/***/ 83411:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"whyCinchContainer":"why-cinch_whyCinchContainer__jM2ii","whyCinchInner":"why-cinch_whyCinchInner__jrEQm","whyCinchHeading":"why-cinch_whyCinchHeading__s2CDp","contentWrapper":"why-cinch_contentWrapper__jBy2d","cardWithIcon":"why-cinch_cardWithIcon__33vWo","whyCinchImageContainer":"why-cinch_whyCinchImageContainer__PQ5Qq","contentSectionWrapper":"why-cinch_contentSectionWrapper__jlSMe","contentSectionTitle":"why-cinch_contentSectionTitle__7815V","contentSectionBody":"why-cinch_contentSectionBody__Ynn8P","bulletContainer":"why-cinch_bulletContainer__LykLg","listItem":"why-cinch_listItem__fLSao"};

/***/ }),

/***/ 46567:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"trustpilotScore":"homepage_trustpilotScore__ul5D4","heading":"homepage_heading__5LlYT","valuePropsCardsContainer":"homepage_valuePropsCardsContainer__ifg_K","zeroFox":"homepage_zeroFox__cj1ZT"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1249,9774,2888,179], function() { return __webpack_exec__(4878); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);